import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
  color?: string;
  fill?: string;
  fillBack?: string;
}

// User Profile Icon
export const UserProfileIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M169.16 100.87C169.06 100.86 168.94 100.86 168.83 100.87C166.45 100.79 164.56 98.84 164.56 96.44C164.56 93.99 166.54 92 169 92C171.45 92 173.44 93.99 173.44 96.44C173.43 98.84 171.54 100.79 169.16 100.87Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M176.41 94C178.35 94 179.91 95.57 179.91 97.5C179.91 99.39 178.41 100.93 176.54 101C176.46 100.99 176.37 100.99 176.28 101" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M164.16 104.56C161.74 106.18 161.74 108.82 164.16 110.43C166.91 112.27 171.42 112.27 174.17 110.43C176.59 108.81 176.59 106.17 174.17 104.56C171.43 102.73 166.92 102.73 164.16 104.56Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M178.34 110C179.06 109.85 179.74 109.56 180.3 109.13C181.86 107.96 181.86 106.03 180.3 104.86C179.75 104.44 179.08 104.16 178.37 104" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Grid Layout Icon
export const GridLayoutIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M101 100H103C105 100 106 99 106 97V95C106 93 105 92 103 92H101C99 92 98 93 98 95V97C98 99 99 100 101 100Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M113 100H115C117 100 118 99 118 97V95C118 93 117 92 115 92H113C111 92 110 93 110 95V97C110 99 111 100 113 100Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M113 112H115C117 112 118 111 118 109V107C118 105 117 104 115 104H113C111 104 110 105 110 107V109C110 111 111 112 113 112Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M101 112H103C105 112 106 111 106 109V107C106 105 105 104 103 104H101C99 104 98 105 98 107V109C98 111 99 112 101 112Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// User Avatar Icon
export const UserAvatarIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M270.14 111.62C269.26 111.88 268.22 112 267 112H261C259.78 112 258.74 111.88 257.86 111.62C258.08 109.02 260.75 106.97 264 106.97C267.25 106.97 269.92 109.02 270.14 111.62Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M267 92H261C256 92 254 94 254 99V105C254 108.78 255.14 110.85 257.86 111.62C258.08 109.02 260.75 106.97 264 106.97C267.25 106.97 269.92 109.02 270.14 111.62C272.86 110.85 274 108.78 274 105V99C274 94 272 92 267 92ZM264 104.17C262.02 104.17 260.42 102.56 260.42 100.58C260.42 98.6 262.02 97 264 97C265.98 97 267.58 98.6 267.58 100.58C267.58 102.56 265.98 104.17 264 104.17Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M267.58 100.58C267.58 102.56 265.98 104.17 264 104.17C262.02 104.17 260.42 102.56 260.42 100.58C260.42 98.6 262.02 97 264 97C265.98 97 267.58 98.6 267.58 100.58Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Settings Icon
export const SettingsIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M146 111H136C132 111 131 110 131 106V98C131 94 132 93 136 93H146C150 93 151 94 151 98V106C151 110 150 111 146 111Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M143 98H148" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M144 102H148" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M146 106H148" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M137.5 101.29C138.5 101.29 139.31 100.48 139.31 99.4799C139.31 98.4803 138.5 97.6699 137.5 97.6699C136.5 97.6699 135.69 98.4803 135.69 99.4799C135.69 100.48 136.5 101.29 137.5 101.29Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M141 106.33C140.86 104.88 139.71 103.74 138.26 103.61C137.76 103.56 137.25 103.56 136.74 103.61C135.29 103.75 134.14 104.88 134 106.33" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Check Icon
export const CheckIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M204.37 98.8799H209.62" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M198.38 98.8799L199.13 99.6299L201.38 97.3799" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M204.37 105.88H209.62" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M198.38 105.88L199.13 106.63L201.38 104.38" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M201 112H207C212 112 214 110 214 105V99C214 94 212 92 207 92H201C196 92 194 94 194 99V105C194 110 196 112 201 112Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Star Icon
export const StarIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M240.32 102C242.92 102 244 101 243.04 97.7202C242.39 95.5102 240.49 93.6102 238.28 92.9602C235 92.0002 234 93.0802 234 95.6802V98.5602C234 101 235 102 237 102H240.32Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M242 104.7C241.07 109.33 236.63 112.69 231.58 111.87C227.79 111.26 224.74 108.21 224.12 104.42C223.31 99.3898 226.65 94.9498 231.26 94.0098" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Dots Icon
export const DotsIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M283 100C281.9 100 281 100.9 281 102C281 103.1 281.9 104 283 104C284.1 104 285 103.1 285 102C285 100.9 284.1 100 283 100Z" 
      stroke={color} 
      strokeWidth="1.5"
    />
    <path 
      d="M297 100C295.9 100 295 100.9 295 102C295 103.1 295.9 104 297 104C298.1 104 299 103.1 299 102C299 100.9 298.1 100 297 100Z" 
      stroke={color} 
      strokeWidth="1.5"
    />
    <path 
      d="M290 100C288.9 100 288 100.9 288 102C288 103.1 288.9 104 290 104C291.1 104 292 103.1 292 102C292 100.9 291.1 100 290 100Z" 
      stroke={color} 
      strokeWidth="1.5"
    />
  </svg>
);

// Chevron Down Icon
export const ChevronDownIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M100.47 135.97C100.736 135.703 101.153 135.679 101.446 135.897L101.53 135.97L108 142.439L114.47 135.97C114.736 135.703 115.153 135.679 115.446 135.897L115.53 135.97C115.797 136.236 115.821 136.653 115.603 136.946L115.53 137.03L108.53 144.03C108.264 144.297 107.847 144.321 107.554 144.103L107.47 144.03L100.47 137.03C100.177 136.737 100.177 136.263 100.47 135.97Z" 
      fill={color}
    />
  </svg>
);

// Chevron Up Icon
export const ChevronUpIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M200.5 142.5L204 145.5L207.5 142.5" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M200.5 137.5L204 134.5L207.5 137.5" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Close Icon
export const CloseIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M136.757 144.243L145.243 135.757" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M145.243 144.243L136.757 135.757" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Search Icon
export const SearchIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M172.16 138.87C172.06 138.86 171.94 138.86 171.83 138.87C169.45 138.79 167.56 136.84 167.56 134.44C167.56 131.99 169.54 130 172 130C174.45 130 176.44 131.99 176.44 134.44C176.43 136.84 174.54 138.79 172.16 138.87Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M167.16 142.56C164.74 144.18 164.74 146.82 167.16 148.43C169.91 150.27 174.42 150.27 177.17 148.43C179.59 146.81 179.59 144.17 177.17 142.56C174.43 140.73 169.92 140.73 167.16 142.56Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Plus Icon
export const PlusIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M264 150C269.5 150 274 145.5 274 140C274 134.5 269.5 130 264 130C258.5 130 254 134.5 254 140C254 145.5 258.5 150 264 150Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M260 140H268" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M264 144V136" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Notification Icon
export const NotificationIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M106.085 167C101.805 167 98.335 170.47 98.335 174.75V175.454C98.335 176.151 98.1287 176.832 97.7421 177.412L96.5935 179.135C95.2604 181.135 96.2781 183.853 98.5967 184.485C99.3523 184.691 100.114 184.866 100.881 185.008L100.883 185.013C101.652 187.065 103.707 188.5 106.085 188.5C108.463 188.5 110.518 187.065 111.287 185.013L111.289 185.008C112.056 184.866 112.818 184.691 113.573 184.485C115.892 183.853 116.91 181.135 115.576 179.135L114.428 177.412C114.041 176.832 113.835 176.151 113.835 175.454V174.75C113.835 170.47 110.365 167 106.085 167ZM109.461 185.287C107.218 185.555 104.951 185.555 102.708 185.287C103.419 186.308 104.656 187 106.085 187C107.514 187 108.75 186.308 109.461 185.287ZM99.835 174.75C99.835 171.298 102.633 168.5 106.085 168.5C109.537 168.5 112.335 171.298 112.335 174.75V175.454C112.335 176.447 112.629 177.418 113.18 178.244L114.328 179.967C115.094 181.115 114.509 182.675 113.179 183.038C108.534 184.305 103.636 184.305 98.9914 183.038C97.6606 182.675 97.0764 181.115 97.8416 179.967L98.9902 178.244C99.5411 177.418 99.835 176.447 99.835 175.454V174.75Z" 
      fill={color}
    />
    <rect x="104.5" y="162.5" width="17" height="17" rx="8.5" fill="#C20E4C"/>
    <rect x="104.5" y="162.5" width="17" height="17" rx="8.5" stroke="white"/>
    <path 
      d="M112.984 175.099C112.567 175.099 112.192 175.017 111.858 174.851C111.524 174.685 111.257 174.458 111.055 174.169C110.854 173.88 110.744 173.551 110.725 173.182H111.577C111.61 173.511 111.76 173.783 112.025 173.999C112.292 174.212 112.612 174.318 112.984 174.318C113.282 174.318 113.547 174.248 113.779 174.109C114.013 173.969 114.197 173.777 114.329 173.533C114.464 173.287 114.532 173.009 114.532 172.699C114.532 172.382 114.462 172.099 114.322 171.85C114.185 171.599 113.996 171.402 113.754 171.257C113.513 171.113 113.237 171.039 112.927 171.037C112.704 171.035 112.476 171.069 112.241 171.14C112.007 171.209 111.814 171.297 111.663 171.406L110.839 171.307L111.279 167.727H115.057V168.509H112.018L111.762 170.653H111.805C111.954 170.535 112.141 170.437 112.366 170.359C112.591 170.281 112.825 170.241 113.069 170.241C113.514 170.241 113.91 170.348 114.258 170.561C114.609 170.772 114.883 171.061 115.082 171.428C115.284 171.795 115.384 172.214 115.384 172.685C115.384 173.149 115.28 173.563 115.072 173.928C114.866 174.29 114.582 174.576 114.219 174.787C113.857 174.995 113.445 175.099 112.984 175.099Z" 
      fill="white"
    />
  </svg>
); 

export const InfoIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 36, 
  color = "currentColor",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#E0EDFC"/>
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#B3CEF0"/>
    <path d="M18 10C13.582 10 10 13.582 10 18C10 22.418 13.582 26 18 26C22.418 26 26 22.418 26 18C26 13.582 22.418 10 18 10ZM18.6667 22H17.3333V17.3333H18.6667V22ZM18 15.6667C17.448 15.6667 17 15.2187 17 14.6667C17 14.1147 17.448 13.6667 18 13.6667C18.552 13.6667 19 14.1147 19 14.6667C19 15.2187 18.552 15.6667 18 15.6667Z" fill="#006FEE"/>
  </svg>

);

export const SuccessIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 36, 
  color = "currentColor",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#E8FAF0"/>
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#D1F2E0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M24.6668 18C24.6668 21.6819 21.6821 24.6667 18.0002 24.6667C14.3183 24.6667 11.3335 21.6819 11.3335 18C11.3335 14.3181 14.3183 11.3334 18.0002 11.3334C21.6821 11.3334 24.6668 14.3181 24.6668 18ZM20.687 15.9798C20.8823 16.1751 20.8823 16.4917 20.687 16.6869L17.3537 20.0203C17.1585 20.2155 16.8419 20.2155 16.6466 20.0203L15.3133 18.6869C15.118 18.4917 15.118 18.1751 15.3133 17.9798C15.5085 17.7846 15.8251 17.7846 16.0204 17.9798L17.0002 18.9596L18.4901 17.4697L19.9799 15.9798C20.1752 15.7846 20.4918 15.7846 20.687 15.9798Z" fill="#0E793C"/>
  </svg>
);

export const InfoCircle: React.FC<IconProps> = ({
  className = "", 
  size = 16, 
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065ZM7.99992 11.834C8.27606 11.834 8.49992 11.6101 8.49992 11.334V7.33398C8.49992 7.05784 8.27606 6.83398 7.99992 6.83398C7.72378 6.83398 7.49992 7.05784 7.49992 7.33398V11.334C7.49992 11.6101 7.72378 11.834 7.99992 11.834ZM7.99992 4.66732C8.36811 4.66732 8.66659 4.96579 8.66659 5.33398C8.66659 5.70217 8.36811 6.00065 7.99992 6.00065C7.63173 6.00065 7.33325 5.70217 7.33325 5.33398C7.33325 4.96579 7.63173 4.66732 7.99992 4.66732Z" fill="#A8A8B0"/>
  </svg>

)
export const IcDate : React.FC<IconProps> = ({
  className = "", 
  size = 14, 
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.25 4.08333V3.64583C12.25 2.6005 11.3995 1.75 10.3542 1.75H3.64583C2.6005 1.75 1.75 2.6005 1.75 3.64583V4.08333H12.25ZM1.75 4.95833V10.3542C1.75 11.3995 2.6005 12.25 3.64583 12.25H10.3542C11.3995 12.25 12.25 11.3995 12.25 10.3542V4.95833H1.75ZM4.52083 10.5C4.11804 10.5 3.79167 10.1736 3.79167 9.77083C3.79167 9.36804 4.11804 9.04167 4.52083 9.04167C4.92362 9.04167 5.25 9.36804 5.25 9.77083C5.25 10.1736 4.92362 10.5 4.52083 10.5ZM4.52083 7.875C4.11804 7.875 3.79167 7.54862 3.79167 7.14583C3.79167 6.74304 4.11804 6.41667 4.52083 6.41667C4.92362 6.41667 5.25 6.74304 5.25 7.14583C5.25 7.54862 4.92362 7.875 4.52083 7.875ZM7 10.5C6.59721 10.5 6.27083 10.1736 6.27083 9.77083C6.27083 9.36804 6.59721 9.04167 7 9.04167C7.40279 9.04167 7.72917 9.36804 7.72917 9.77083C7.72917 10.1736 7.40279 10.5 7 10.5ZM7 7.875C6.59721 7.875 6.27083 7.54862 6.27083 7.14583C6.27083 6.74304 6.59721 6.41667 7 6.41667C7.40279 6.41667 7.72917 6.74304 7.72917 7.14583C7.72917 7.54862 7.40279 7.875 7 7.875ZM9.47917 7.875C9.07637 7.875 8.75 7.54862 8.75 7.14583C8.75 6.74304 9.07637 6.41667 9.47917 6.41667C9.88196 6.41667 10.2083 6.74304 10.2083 7.14583C10.2083 7.54862 9.88196 7.875 9.47917 7.875Z" fill="#71717A"/>
  </svg>

)

export const UserNoAvatarIcon: React.FC<IconProps> = ({
  className = "", 
  size = 20, 
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18.3334 9.99935C18.3334 14.6017 14.6025 18.3327 10.0001 18.3327C5.39771 18.3327 1.66675 14.6017 1.66675 9.99935C1.66675 5.39698 5.39771 1.66602 10.0001 1.66602C14.6025 1.66602 18.3334 5.39698 18.3334 9.99935ZM12.5001 7.49935C12.5001 8.88006 11.3808 9.99935 10.0001 9.99935C8.61937 9.99935 7.50008 8.88006 7.50008 7.49935C7.50008 6.11864 8.61937 4.99935 10.0001 4.99935C11.3808 4.99935 12.5001 6.11864 12.5001 7.49935ZM10.0001 17.0827C11.4868 17.0827 12.8665 16.6247 14.0058 15.842C14.5091 15.4963 14.7241 14.8379 14.4316 14.302C13.825 13.1912 12.5753 12.4993 10 12.4993C7.42482 12.4993 6.17505 13.1912 5.56853 14.302C5.27595 14.8378 5.491 15.4963 5.99421 15.842C7.13357 16.6246 8.51333 17.0827 10.0001 17.0827Z" fill="#A8A8B0"/>
  </svg>

)

export const LinkIcon: React.FC<IconProps> = ({
  className = "", 
  size = 18, 
  fill='#006FEE'
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.49998 5.25C2.30773 5.25 0.554557 7.13118 0.767557 9.36768C0.953557 11.3177 2.70211 12.75 4.66111 12.75H6.74998C7.16398 12.75 7.49998 12.414 7.49998 12C7.49998 11.586 7.16398 11.25 6.74998 11.25H4.62742C3.40942 11.25 2.31737 10.3374 2.25437 9.12012C2.18612 7.82262 3.21748 6.75 4.49998 6.75H6.74998C7.16398 6.75 7.49998 6.414 7.49998 6C7.49998 5.586 7.16398 5.25 6.74998 5.25H4.49998ZM11.25 5.25C10.836 5.25 10.5 5.586 10.5 6C10.5 6.414 10.836 6.75 11.25 6.75H13.3725C14.5905 6.75 15.6826 7.66263 15.7456 8.87988C15.8138 10.1774 14.7825 11.25 13.5 11.25H11.25C10.836 11.25 10.5 11.586 10.5 12C10.5 12.414 10.836 12.75 11.25 12.75H13.5C15.6922 12.75 17.4454 10.8688 17.2324 8.63232C17.0464 6.68232 15.2978 5.25 13.3388 5.25H11.25ZM5.99998 8.25C5.58598 8.25 5.24998 8.586 5.24998 9C5.24998 9.414 5.58598 9.75 5.99998 9.75H12C12.414 9.75 12.75 9.414 12.75 9C12.75 8.586 12.414 8.25 12 8.25H5.99998Z" fill={fill}/>
  </svg>
)

export const GoogleIc : React.FC<IconProps> = ({
  className = "", 
  size = 14, 
  fill = "#71717A"
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00172 1.40039C3.90819 1.40039 1.3999 3.90779 1.3999 7.00039C1.3999 10.093 3.90819 12.6004 7.00172 12.6004C11.6731 12.6004 12.7255 8.26366 12.2873 6.06706H11.6666H10.6084H6.9999V7.93372H10.6111C10.196 9.54291 8.73868 10.7337 6.9999 10.7337C4.93817 10.7337 3.26657 9.06212 3.26657 7.00039C3.26657 4.93866 4.93817 3.26706 6.9999 3.26706C7.93744 3.26706 8.7915 3.61507 9.44717 4.18581L10.7733 2.86055C9.77747 1.95335 8.45446 1.40039 7.00172 1.40039Z" fill={fill}/>
  </svg>

)

export const InstagramIc : React.FC<IconProps> = ({
  className = "",
  size = 14, 
  fill = "#71717A"
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.66667 1.75C3.05608 1.75 1.75 3.05608 1.75 4.66667V9.33333C1.75 10.9439 3.05608 12.25 4.66667 12.25H9.33333C10.9439 12.25 12.25 10.9439 12.25 9.33333V4.66667C12.25 3.05608 10.9439 1.75 9.33333 1.75H4.66667ZM10.5 2.91667C10.822 2.91667 11.0833 3.178 11.0833 3.5C11.0833 3.822 10.822 4.08333 10.5 4.08333C10.178 4.08333 9.91667 3.822 9.91667 3.5C9.91667 3.178 10.178 2.91667 10.5 2.91667ZM7 4.08333C8.61058 4.08333 9.91667 5.38942 9.91667 7C9.91667 8.61058 8.61058 9.91667 7 9.91667C5.38942 9.91667 4.08333 8.61058 4.08333 7C4.08333 5.38942 5.38942 4.08333 7 4.08333ZM7 5.25C6.53587 5.25 6.09075 5.43437 5.76256 5.76256C5.43437 6.09075 5.25 6.53587 5.25 7C5.25 7.46413 5.43437 7.90925 5.76256 8.23744C6.09075 8.56563 6.53587 8.75 7 8.75C7.46413 8.75 7.90925 8.56563 8.23744 8.23744C8.56563 7.90925 8.75 7.46413 8.75 7C8.75 6.53587 8.56563 6.09075 8.23744 5.76256C7.90925 5.43437 7.46413 5.25 7 5.25Z" fill={fill}/>
  </svg>
)

export const TwitterIc : React.FC<IconProps> = ({
  className = "",
  size = 14, 
  fill = "#71717A"
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.40426 12.6879C9.68598 12.6879 12.5757 8.311 12.5757 4.51651C12.5757 4.39347 12.5729 4.26768 12.5675 4.14464C13.1296 3.73811 13.6147 3.23458 14 2.65768C13.4765 2.89061 12.9206 3.04273 12.3514 3.10886C12.9507 2.74962 13.3995 2.18529 13.6145 1.52046C13.0507 1.85459 12.4341 2.09028 11.7912 2.21745C11.358 1.75717 10.7852 1.45241 10.1615 1.35029C9.53772 1.24817 8.89769 1.35437 8.34035 1.65248C7.783 1.95059 7.33938 2.42401 7.07808 2.99953C6.81677 3.57505 6.75233 4.22062 6.89473 4.83643C5.75312 4.77915 4.6363 4.48259 3.61666 3.96598C2.59702 3.44938 1.69732 2.72427 0.975898 1.83765C0.609233 2.46982 0.497033 3.21789 0.662101 3.92981C0.82717 4.64174 1.25712 5.2641 1.86457 5.67042C1.40853 5.65594 0.962486 5.53316 0.563281 5.31222V5.34776C0.562873 6.01118 0.792224 6.65427 1.21235 7.16771C1.63247 7.68115 2.21744 8.03325 2.86781 8.16417C2.44537 8.27975 2.00199 8.29659 1.57199 8.21339C1.75552 8.78393 2.11258 9.28295 2.59337 9.64079C3.07415 9.99863 3.65465 10.1974 4.25387 10.2095C3.23658 11.0086 1.97993 11.442 0.686328 11.4399C0.456917 11.4396 0.227733 11.4255 0 11.3978C1.31417 12.2409 2.84289 12.6887 4.40426 12.6879Z" fill={fill}/>
  </svg>

)

export const EyeIc : React.FC<IconProps> = ({
  className = "",
  size = 16, 
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.50016 7.99935C6.50016 7.17092 7.17174 6.49935 8.00016 6.49935C8.82859 6.49935 9.50016 7.17092 9.50016 7.99935C9.50016 8.82778 8.82859 9.49935 8.00016 9.49935C7.17174 9.49935 6.50016 8.82778 6.50016 7.99935Z" fill="#A8A8B0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M1.3335 7.99935C1.3335 9.09227 1.61681 9.46033 2.18342 10.1965C3.31481 11.6663 5.21224 13.3327 8.00016 13.3327C10.7881 13.3327 12.6855 11.6663 13.8169 10.1965C14.3835 9.46033 14.6668 9.09227 14.6668 7.99935C14.6668 6.90643 14.3835 6.53837 13.8169 5.80224C12.6855 4.33239 10.7881 2.66602 8.00016 2.66602C5.21224 2.66602 3.31481 4.33239 2.18342 5.80224C1.61681 6.53837 1.3335 6.90643 1.3335 7.99935ZM8.00016 5.49935C6.61945 5.49935 5.50016 6.61864 5.50016 7.99935C5.50016 9.38006 6.61945 10.4993 8.00016 10.4993C9.38087 10.4993 10.5002 9.38006 10.5002 7.99935C10.5002 6.61864 9.38087 5.49935 8.00016 5.49935Z" fill="#A8A8B0"/>
  </svg>
)

export const ChatRoundedIc: React.FC<IconProps> = ({
  className = "",
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_55587_92437)">
    <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 6.79984 1.18781 7.55582 1.52173 8.22624C1.61047 8.4044 1.64 8.60803 1.58856 8.80031L1.29076 9.91333C1.16148 10.3965 1.60351 10.8385 2.08667 10.7092L3.19969 10.4114C3.39197 10.36 3.5956 10.3895 3.77376 10.4783C4.44418 10.8122 5.20016 11 6 11Z" stroke="#71717A"/>
    <path d="M4 5.25H8" stroke="#71717A" strokeLinecap="round"/>
    <path d="M4 7H6.75" stroke="#71717A" strokeLinecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_55587_92437">
    <rect 
      width={size} 
      height={size} 
      fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const GroupUserIc: React.FC<IconProps> = ({
  className = "",
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="3" r="2" stroke="#71717A"/>
    <path d="M9 4.5C9.82843 4.5 10.5 3.94036 10.5 3.25C10.5 2.55964 9.82843 2 9 2" stroke="#71717A" strokeLinecap="round"/>
    <path d="M3 4.5C2.17157 4.5 1.5 3.94036 1.5 3.25C1.5 2.55964 2.17157 2 3 2" stroke="#71717A" strokeLinecap="round"/>
    <ellipse cx="6" cy="8.5" rx="3" ry="2" stroke="#71717A"/>
    <path d="M10 9.5C10.8771 9.30765 11.5 8.82053 11.5 8.25C11.5 7.67947 10.8771 7.19235 10 7" stroke="#71717A" strokeLinecap="round"/>
    <path d="M2 9.5C1.12288 9.30765 0.5 8.82053 0.5 8.25C0.5 7.67947 1.12288 7.19235 2 7" stroke="#71717A" strokeLinecap="round"/>
  </svg>
)

export const MoneyIc : React.FC<IconProps> = ({
  className = "", 
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 9.5C3.09554 9.5 2.39331 9.5 1.88886 9.16294C1.67048 9.01702 1.48298 8.82952 1.33706 8.61114C1 8.10669 1 7.40446 1 6C1 4.59554 1 3.89331 1.33706 3.38886C1.48298 3.17048 1.67048 2.98298 1.88886 2.83706C2.39331 2.5 3.09554 2.5 4.5 2.5L7.5 2.5C8.90446 2.5 9.60669 2.5 10.1111 2.83706C10.3295 2.98298 10.517 3.17048 10.6629 3.38886C11 3.89331 11 4.59554 11 6C11 7.40446 11 8.10669 10.6629 8.61114C10.517 8.82952 10.3295 9.01702 10.1111 9.16294C9.60669 9.5 8.90446 9.5 7.5 9.5H4.5Z" stroke="#71717A"/>
    <path d="M4.5 4.5C3.67157 4.5 3 5.17157 3 6C3 6.82843 3.67157 7.5 4.5 7.5" stroke="#71717A"/>
    <path d="M7.5 4.5C8.32843 4.5 9 5.17157 9 6C9 6.82843 8.32843 7.5 7.5 7.5" stroke="#71717A"/>
    <path d="M4.5 2.5V9.25" stroke="#71717A" strokeLinecap="round"/>
    <path d="M7.5 2.5V9.25" stroke="#71717A" strokeLinecap="round"/>
  </svg>
)

export const UserCheckIc : React.FC<IconProps> = ({
  className = "", 
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="3" r="2" stroke="#71717A"/>
    <circle cx="9" cy="8" r="2" stroke="#71717A"/>
    <path d="M8.33301 7.99913L8.74976 8.49913L9.66634 7.55469" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 6.66355C7.03678 6.55808 6.53045 6.5 6 6.5C3.79086 6.5 2 7.50736 2 8.75C2 9.99264 2 11 6 11C8.84372 11 9.66575 10.4909 9.90338 9.75" stroke="#71717A"/>
  </svg>
)

export const InfoIconBlue: React.FC<IconProps> = ({
  className = "", 
  size = 36,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#E0EDFC"/>
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#B3CEF0"/>
    <path d="M18 10C13.582 10 10 13.582 10 18C10 22.418 13.582 26 18 26C22.418 26 26 22.418 26 18C26 13.582 22.418 10 18 10ZM18.6667 22H17.3333V17.3333H18.6667V22ZM18 15.6667C17.448 15.6667 17 15.2187 17 14.6667C17 14.1147 17.448 13.6667 18 13.6667C18.552 13.6667 19 14.1147 19 14.6667C19 15.2187 18.552 15.6667 18 15.6667Z" fill="#006FEE"/>
  </svg>
)

export const InfoSuccessGreen: React.FC<IconProps> = ({
  className = "", 
  size = 36,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#E8FAF0"/>
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#D1F2E0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M24.6668 18C24.6668 21.6819 21.6821 24.6667 18.0002 24.6667C14.3183 24.6667 11.3335 21.6819 11.3335 18C11.3335 14.3181 14.3183 11.3334 18.0002 11.3334C21.6821 11.3334 24.6668 14.3181 24.6668 18ZM20.687 15.9798C20.8823 16.1751 20.8823 16.4917 20.687 16.6869L17.3537 20.0203C17.1585 20.2155 16.8419 20.2155 16.6466 20.0203L15.3133 18.6869C15.118 18.4917 15.118 18.1751 15.3133 17.9798C15.5085 17.7846 15.8251 17.7846 16.0204 17.9798L17.0002 18.9596L18.4901 17.4697L19.9799 15.9798C20.1752 15.7846 20.4918 15.7846 20.687 15.9798Z" fill="#0E793C"/>
  </svg>
)

export const NoAvatarBigIc: React.FC<IconProps> = ({
  className = "", 
  size = 200,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="200" height="200" rx="12" fill="#E9E9E9"/>
    <path d="M100 44C84.5347 44 72 56.5347 72 72V76.6667C72 92.132 84.5347 104.667 100 104.667C115.465 104.667 128 92.132 128 76.6667V72C128 56.5347 115.465 44 100 44ZM99.9909 118.667C81.2962 118.667 57.3095 128.779 50.4075 137.753C46.1422 143.301 50.2026 151.333 57.1979 151.333H142.793C149.788 151.333 153.849 143.301 149.583 137.753C142.681 128.783 118.686 118.667 99.9909 118.667Z" fill="black" fill-opacity="0.2"/>
  </svg>

)

export const EditBlueRoundedIc: React.FC<IconProps> = ({
  className = "", 
  size = 44,
  fill='#9675CE',
  fillBack='#F1E8FF',
}) => (
  // "#FAF8FF"
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_0_17088)">
    <rect x="6" y="6" width="32" height="32" rx="16" fill={fillBack} shape-rendering="crispEdges"/>
    <rect x="6.5" y="6.5" width="31" height="31" rx="15.5" stroke={fillBack} stroke-opacity="0.2" shape-rendering="crispEdges"/>
    <g clipPath="url(#clip0_0_17088)">
    <path d="M23.5734 16.7191L24.1913 16.1012C25.2151 15.0774 26.875 15.0774 27.8988 16.1012C28.9226 17.125 28.9226 18.7849 27.8988 19.8087L27.2809 20.4266M23.5734 16.7191C23.5734 16.7191 23.6506 18.0322 24.8092 19.1908C25.9678 20.3494 27.2809 20.4266 27.2809 20.4266M23.5734 16.7191L17.8926 22.3999C17.5078 22.7847 17.3154 22.9771 17.1499 23.1892C16.9548 23.4395 16.7874 23.7102 16.6509 23.9967C16.5352 24.2395 16.4491 24.4976 16.2771 25.0139L15.5479 27.2014M27.2809 20.4266L21.6001 26.1074C21.2153 26.4922 21.0229 26.6846 20.8108 26.8501C20.5606 27.0452 20.2898 27.2126 20.0033 27.3491C19.7605 27.4648 19.5024 27.5509 18.9861 27.723L16.7986 28.4521M16.7986 28.4521L16.2639 28.6304C16.0099 28.715 15.7298 28.6489 15.5404 28.4596C15.3511 28.2702 15.285 27.9901 15.3696 27.7361L15.5479 27.2014M16.7986 28.4521L15.5479 27.2014" stroke={fill} strokeWidth="1.5"/>
    </g>
    </g>
    <defs>
    <filter id="filter0_d_0_17088" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.317647 0 0 0 0 0.737255 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_17088"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_17088" result="shape"/>
    </filter>
    <clipPath id="clip0_0_17088">
    <rect width="16" height="16" fill="white" transform="translate(14 14)"/>
    </clipPath>
    </defs>
  </svg>
)

export const InfoRedIc : React.FC<IconProps> = ({
  className = "", 
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00001 0.600006C3.46561 0.600006 0.600006 3.46561 0.600006 7.00001C0.600006 10.5344 3.46561 13.4 7.00001 13.4C10.5344 13.4 13.4 10.5344 13.4 7.00001C13.4 3.46561 10.5344 0.600006 7.00001 0.600006ZM7.53334 10.2H6.46667V6.46667H7.53334V10.2ZM7.00001 5.13334C6.55841 5.13334 6.20001 4.77494 6.20001 4.33334C6.20001 3.89174 6.55841 3.53334 7.00001 3.53334C7.44161 3.53334 7.80001 3.89174 7.80001 4.33334C7.80001 4.77494 7.44161 5.13334 7.00001 5.13334Z" fill="#BC1548"/>
  </svg>

)

export const UsdcCoinIc: React.FC<IconProps> = ({
  className = "", 
  size = 20,
  fill="white",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.0833 14.0833C16.3333 11.8333 16.3333 8.08325 14.0833 5.83325" stroke={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.91667 5.91675C3.66667 8.16675 3.66667 11.9167 5.91667 14.1667" stroke={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.08333 11.3333C8.08333 12.0833 8.66666 12.6666 9.41666 12.6666H10.8333C11.4167 12.6666 12 12.1666 12 11.4999C12 10.7499 11.6667 10.4999 11.25 10.3333L8.91666 9.49992C8.33333 9.41658 8.08333 9.16658 8.08333 8.49992C8.08333 7.83325 8.58333 7.33325 9.25 7.33325H10.75C11.5 7.33325 12.0833 7.91658 12.0833 8.66658" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 6.5V13.5" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 10 1.66675C5.39763 1.66675 1.66667 5.39771 1.66667 10.0001C1.66667 14.6025 5.39763 18.3334 10 18.3334Z" stroke={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const EmptyContentIc: React.FC<IconProps> = ({className = ""}) => (
  <svg width="201" height="141" className={className} viewBox="0 0 201 141" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M162.5 0H42.5C36.9772 0 32.5 4.47715 32.5 10V130C32.5 135.523 36.9772 140 42.5 140H162.5C168.023 140 172.5 135.523 172.5 130V10C172.5 4.47715 168.023 0 162.5 0Z" fill="url(#paint0_linear_55594_191704)"/>
    <g filter="url(#filter0_d_55594_191704)">
    <path d="M54.5 54H189.5C190.826 54 192.098 54.5268 193.036 55.4645C193.973 56.4021 194.5 57.6739 194.5 59V84C194.5 85.3261 193.973 86.5979 193.036 87.5355C192.098 88.4732 190.826 89 189.5 89H54.5C53.1739 89 51.9021 88.4732 50.9645 87.5355C50.0268 86.5979 49.5 85.3261 49.5 84V59C49.5 57.6739 50.0268 56.4021 50.9645 55.4645C51.9021 54.5268 53.1739 54 54.5 54V54Z" fill="white"/>
    </g>
    <path d="M128.5 62H102.5C100.843 62 99.5 63.3431 99.5 65C99.5 66.6569 100.843 68 102.5 68H128.5C130.157 68 131.5 66.6569 131.5 65C131.5 63.3431 130.157 62 128.5 62Z" fill="#B4DAFF"/>
    <path d="M146.5 75H102.5C100.843 75 99.5 76.3431 99.5 78C99.5 79.6569 100.843 81 102.5 81H146.5C148.157 81 149.5 79.6569 149.5 78C149.5 76.3431 148.157 75 146.5 75Z" fill="#DEE9FC"/>
    <path d="M80 81C85.2467 81 89.5 76.7467 89.5 71.5C89.5 66.2533 85.2467 62 80 62C74.7533 62 70.5 66.2533 70.5 71.5C70.5 76.7467 74.7533 81 80 81Z" fill="#1485FD"/>
    <g filter="url(#filter1_d_55594_191704)">
    <path d="M11.5 97H146.5C147.826 97 149.098 97.5268 150.036 98.4645C150.973 99.4021 151.5 100.674 151.5 102V127C151.5 128.326 150.973 129.598 150.036 130.536C149.098 131.473 147.826 132 146.5 132H11.5C10.1739 132 8.90215 131.473 7.96447 130.536C7.02678 129.598 6.5 128.326 6.5 127V102C6.5 100.674 7.02678 99.4021 7.96447 98.4645C8.90215 97.5268 10.1739 97 11.5 97V97Z" fill="white"/>
    </g>
    <path d="M85.5 105H59.5C57.8431 105 56.5 106.343 56.5 108C56.5 109.657 57.8431 111 59.5 111H85.5C87.1569 111 88.5 109.657 88.5 108C88.5 106.343 87.1569 105 85.5 105Z" fill="#B4DAFF"/>
    <path d="M103.5 118H59.5C57.8431 118 56.5 119.343 56.5 121C56.5 122.657 57.8431 124 59.5 124H103.5C105.157 124 106.5 122.657 106.5 121C106.5 119.343 105.157 118 103.5 118Z" fill="#DEE9FC"/>
    <path d="M24 124C29.2467 124 33.5 119.747 33.5 114.5C33.5 109.253 29.2467 105 24 105C18.7533 105 14.5 109.253 14.5 114.5C14.5 119.747 18.7533 124 24 124Z" fill="#1485FD"/>
    <g filter="url(#filter2_d_55594_191704)">
    <path d="M146.5 11H11.5C8.73858 11 6.5 13.2386 6.5 16V41C6.5 43.7614 8.73858 46 11.5 46H146.5C149.261 46 151.5 43.7614 151.5 41V16C151.5 13.2386 149.261 11 146.5 11Z" fill="white"/>
    </g>
    <path d="M83.5 19H57.5C55.8431 19 54.5 20.3431 54.5 22C54.5 23.6569 55.8431 25 57.5 25H83.5C85.1569 25 86.5 23.6569 86.5 22C86.5 20.3431 85.1569 19 83.5 19Z" fill="#B4DAFF"/>
    <path d="M101.5 32H57.5C55.8431 32 54.5 33.3431 54.5 35C54.5 36.6569 55.8431 38 57.5 38H101.5C103.157 38 104.5 36.6569 104.5 35C104.5 33.3431 103.157 32 101.5 32Z" fill="#DEE9FC"/>
    <path d="M37 38C42.2467 38 46.5 33.7467 46.5 28.5C46.5 23.2533 42.2467 19 37 19C31.7533 19 27.5 23.2533 27.5 28.5C27.5 33.7467 31.7533 38 37 38Z" fill="#1485FD"/>
    <defs>
    <filter id="filter0_d_55594_191704" x="43.5" y="51" width="157" height="47" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="3"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55594_191704"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55594_191704" result="shape"/>
    </filter>
    <filter id="filter1_d_55594_191704" x="0.5" y="94" width="157" height="47" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="3"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55594_191704"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55594_191704" result="shape"/>
    </filter>
    <filter id="filter2_d_55594_191704" x="0.5" y="8" width="157" height="47" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="3"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55594_191704"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55594_191704" result="shape"/>
    </filter>
    <linearGradient id="paint0_linear_55594_191704" x1="102.5" y1="0" x2="102.5" y2="140" gradientUnits="userSpaceOnUse">
    <stop stopColor="#E3ECFA"/>
    <stop offset="1" stopColor="#DAE7FF"/>
    </linearGradient>
    </defs>
  </svg>
)
export const EmptyContentClientIc: React.FC<IconProps> = ({className = ""}) => (
  <svg width="187" height="150" className={className} viewBox="0 0 187 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z" fill="#F1E8FF"/>
    <g filter="url(#filter0_d_55593_191428)">
    <path d="M41 34H176C177.326 34 178.598 34.5268 179.536 35.4645C180.473 36.4021 181 37.6739 181 39V64C181 65.3261 180.473 66.5979 179.536 67.5355C178.598 68.4732 177.326 69 176 69H41C39.6739 69 38.4021 68.4732 37.4645 67.5355C36.5268 66.5979 36 65.3261 36 64V39C36 37.6739 36.5268 36.4021 37.4645 35.4645C38.4021 34.5268 39.6739 34 41 34V34Z" fill="white"/>
    </g>
    <path d="M105 42H79C77.3431 42 76 43.3431 76 45C76 46.6569 77.3431 48 79 48H105C106.657 48 108 46.6569 108 45C108 43.3431 106.657 42 105 42Z" fill="#DCCDF5"/>
    <path d="M123 55H79C77.3431 55 76 56.3431 76 58C76 59.6569 77.3431 61 79 61H123C124.657 61 126 59.6569 126 58C126 56.3431 124.657 55 123 55Z" fill="#F1E8FF"/>
    <path d="M68 51.5C68 43.4919 61.5081 37 53.5 37C45.4919 37 39 43.4919 39 51.5C39 59.5081 45.4919 66 53.5 66C61.5081 66 68 59.5081 68 51.5Z" fill="#9675CE"/>
    <path d="M52.6 56.1937C53.8413 56.1935 55.0469 55.7781 56.025 55.0137L59.1 58.0887L60.089 57.0997L57.013 54.0237C57.7858 53.0245 58.1974 51.793 58.1807 50.5299C58.1641 49.2668 57.7201 48.0466 56.9212 47.0682C56.1223 46.0897 55.0155 45.4107 53.7813 45.1418C52.547 44.8729 51.2581 45.0299 50.1245 45.5873C48.991 46.1447 48.0796 47.0696 47.539 48.2113C46.9984 49.353 46.8604 50.6441 47.1475 51.8742C47.4346 53.1043 48.1299 54.2009 49.12 54.9853C50.1102 55.7697 51.3368 56.1956 52.6 56.1937ZM52.6 46.3997C53.4306 46.3997 54.2427 46.646 54.9334 47.1075C55.624 47.569 56.1624 48.225 56.4803 48.9924C56.7981 49.7599 56.8813 50.6043 56.7193 51.4191C56.5572 52.2338 56.1572 52.9821 55.5698 53.5695C54.9824 54.1569 54.2341 54.5569 53.4193 54.719C52.6046 54.881 51.7601 54.7979 50.9927 54.48C50.2252 54.1621 49.5693 53.6238 49.1078 52.9331C48.6463 52.2424 48.4 51.4304 48.4 50.5997C48.4 49.4858 48.8425 48.4175 49.6301 47.6298C50.4178 46.8422 51.4861 46.3997 52.6 46.3997Z" fill="white"/>
    <g filter="url(#filter1_d_55593_191428)">
    <path d="M161 79H26C23.2386 79 21 81.2386 21 84V109C21 111.761 23.2386 114 26 114H161C163.761 114 166 111.761 166 109V84C166 81.2386 163.761 79 161 79Z" fill="white"/>
    </g>
    <path d="M90 87H64C62.3431 87 61 88.3431 61 90C61 91.6569 62.3431 93 64 93H90C91.6569 93 93 91.6569 93 90C93 88.3431 91.6569 87 90 87Z" fill="#DCCDF5"/>
    <path d="M108 100H64C62.3431 100 61 101.343 61 103C61 104.657 62.3431 106 64 106H108C109.657 106 111 104.657 111 103C111 101.343 109.657 100 108 100Z" fill="#F1E8FF"/>
    <path d="M53 96.5C53 88.4919 46.5081 82 38.5 82C30.4919 82 24 88.4919 24 96.5C24 104.508 30.4919 111 38.5 111C46.5081 111 53 104.508 53 96.5Z" fill="#9675CE"/>
    <path d="M37.6 101.194C38.8413 101.193 40.0469 100.778 41.025 100.014L44.1 103.089L45.089 102.1L42.013 99.0237C42.7858 98.0245 43.1974 96.793 43.1807 95.5299C43.1641 94.2668 42.7201 93.0466 41.9212 92.0682C41.1223 91.0897 40.0155 90.4107 38.7813 90.1418C37.547 89.8729 36.2581 90.0299 35.1245 90.5873C33.991 91.1447 33.0796 92.0696 32.539 93.2113C31.9984 94.353 31.8604 95.6441 32.1475 96.8742C32.4346 98.1043 33.1299 99.2009 34.12 99.9853C35.1102 100.77 36.3368 101.196 37.6 101.194ZM37.6 91.3997C38.4306 91.3997 39.2427 91.646 39.9334 92.1075C40.624 92.569 41.1624 93.225 41.4803 93.9924C41.7981 94.7599 41.8813 95.6043 41.7193 96.4191C41.5572 97.2338 41.1572 97.9821 40.5698 98.5695C39.9824 99.1569 39.2341 99.5569 38.4193 99.719C37.6046 99.881 36.7601 99.7979 35.9927 99.48C35.2252 99.1621 34.5693 98.6238 34.1078 97.9331C33.6463 97.2424 33.4 96.4304 33.4 95.5997C33.4 94.4858 33.8425 93.4175 34.6301 92.6298C35.4178 91.8422 36.4861 91.3997 37.6 91.3997Z" fill="white"/>
    <defs>
    <filter id="filter0_d_55593_191428" x="30" y="31" width="157" height="47" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="3"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55593_191428"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55593_191428" result="shape"/>
    </filter>
    <filter id="filter1_d_55593_191428" x="15" y="76" width="157" height="47" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="3"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55593_191428"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55593_191428" result="shape"/>
    </filter>
    </defs>
  </svg>
)
export const EthIc : React.FC<IconProps> = ({
  className = "", 
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.74997 7.58341L9.74997 5.83341C9.91664 5.75008 10.0833 5.75008 10.3333 5.83341L14.3333 7.58341C14.6666 7.75008 15 7.33341 14.75 7.00008L10.5833 1.91675C10.3333 1.58341 9.8333 1.58341 9.5833 1.91675L5.41664 7.00008C5.0833 7.33341 5.41664 7.75008 5.74997 7.58341Z" stroke="#9675CE" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.74997 12.4166L9.74997 14.1666C9.91664 14.2499 10.0833 14.2499 10.3333 14.1666L14.3333 12.4166C14.6666 12.2499 15 12.6666 14.75 12.9999L10.5833 18.0833C10.3333 18.4166 9.8333 18.4166 9.5833 18.0833L5.41664 12.9999C5.0833 12.6666 5.41664 12.2499 5.74997 12.4166Z" stroke="#9675CE" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.0001 7.83325L5.66675 9.99992L10.0001 12.1666L14.3334 9.99992L10.0001 7.83325Z" stroke="#9675CE" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const DoubleArrowRightIc : React.FC<IconProps> = ({
  className = "", 
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33333 12.6666L11.3333 7.99992L7.33333 3.33325" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.66653 12.6666L8.66653 7.99992L4.66653 3.33325" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const LogoCreatorIc : React.FC<IconProps> = ({
  className = "", 
  size = 16,
}) => (
  <svg width="76" height="22" className={className} viewBox="0 0 76 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.94548 21.2792C7.66032 21.2792 6.47012 21.0703 5.38122 20.6525C4.29231 20.2346 3.34901 19.6459 2.53867 18.8798C1.72832 18.1201 1.1079 17.2275 0.664738 16.2019C0.221579 15.1763 0 14.0621 0 12.8465C0 11.631 0.221579 10.4978 0.664738 9.48485C1.1079 8.46558 1.72832 7.57928 2.53867 6.81957C3.34268 6.05987 4.28598 5.4711 5.36855 5.05326C6.4448 4.63543 7.62866 4.42651 8.92015 4.42651C10.2116 4.42651 11.3892 4.63543 12.4718 5.04694C13.548 5.45844 14.4976 6.0472 15.3016 6.8069C16.1057 7.5666 16.7324 8.45925 17.1756 9.48485C17.6187 10.5104 17.8403 11.631 17.8403 12.8592C17.8403 14.0874 17.6187 15.1889 17.1756 16.2209C16.7324 17.2528 16.1057 18.1518 15.3016 18.9115C14.4913 19.6712 13.5543 20.2599 12.4718 20.6714C11.3892 21.0829 10.218 21.2919 8.94548 21.2919V21.2792ZM8.92649 18.0885C9.65453 18.0885 10.3256 17.9619 10.9397 17.7023C11.5538 17.4491 12.0919 17.0819 12.5604 16.607C13.0225 16.1322 13.3897 15.5815 13.643 14.9547C13.8962 14.328 14.0291 13.6252 14.0291 12.8465C14.0291 12.0678 13.9025 11.3714 13.643 10.7384C13.3897 10.1116 13.0289 9.55449 12.5604 9.086C12.0982 8.61119 11.5538 8.25035 10.9397 7.99078C10.3256 7.73755 9.65453 7.60459 8.92649 7.60459C8.19844 7.60459 7.52104 7.73122 6.90062 7.99078C6.2802 8.24401 5.74207 8.61119 5.27992 9.086C4.8241 9.56082 4.46324 10.1116 4.21001 10.7384C3.95678 11.3651 3.82383 12.0678 3.82383 12.8465C3.82383 13.6252 3.95045 14.3216 4.21001 14.9547C4.46324 15.5815 4.8241 16.1386 5.27992 16.607C5.73574 17.0819 6.2802 17.4427 6.90062 17.7023C7.52104 17.9555 8.19844 18.0885 8.92649 18.0885Z" fill="black"/>
    <path d="M19.2267 21.0006V4.69873H22.3479L31.9644 16.4361H30.4513V4.69873H34.1739V21.0006H31.0528L21.4362 9.26326H22.9493V21.0006H19.2267Z" fill="black"/>
    <path d="M36.3327 21.0006V4.69873H40.1312V17.9239H48.26V21.0006H36.339H36.3327Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M66.1447 4.74939L66.1003 4.95199H68.563V13.7392C68.582 16.8413 65.9801 18.7785 62.764 17.8099C60.6305 17.1642 60.0354 15.5118 59.9468 13.5619C59.8835 12.0489 59.9088 10.5168 59.9468 8.9784C59.9594 8.50359 59.9658 8.02245 59.9721 7.54764L55.6671 14.7268C56.7307 24.6093 72.4312 24.4826 72.868 14.0494V4.86335H75.2801C75.2801 4.75573 75.1851 4.64811 75.1028 4.55315C75.0838 4.52782 75.0585 4.50883 75.0458 4.48984C74.4127 3.7428 73.71 3.0274 73.0073 2.31202C72.2919 1.58397 71.5765 0.849603 70.9308 0.089902C70.7282 -0.125347 70.5636 0.0519169 70.4116 0.216519C70.3863 0.241842 70.3673 0.267156 70.342 0.286149C69.6393 0.982541 68.9809 1.71059 68.3225 2.44497C67.6134 3.23 66.9107 4.01502 66.151 4.75573L66.1447 4.74939Z" fill="url(#paint0_linear_56176_25858)"/>
    <path d="M49.5831 21.0006V14.3406L50.4441 16.6197L43.246 4.69873H47.2724L52.7676 13.8278H50.4631L55.9836 4.69873H59.6618L52.5143 16.6197L53.3753 14.3406V21.0006H49.5831Z" fill="black"/>
    <defs>
    <linearGradient id="paint0_linear_56176_25858" x1="56.0001" y1="34.5" x2="76.5001" y2="-1.35508e-06" gradientUnits="userSpaceOnUse">
    <stop stopColor="#B39DDB"/>
    <stop offset="1" stopColor="#9675CE"/>
    </linearGradient>
    </defs>
  </svg>
)

export const SettingsIc : React.FC<IconProps> = ({
  className = "", 
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} 
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.05 4.6107C9.145 4.6107 8.775 3.9707 9.225 3.1857C9.485 2.7307 9.33 2.1507 8.875 1.8907L8.01 1.3957C7.615 1.1607 7.105 1.3007 6.87 1.6957L6.815 1.7907C6.365 2.5757 5.625 2.5757 5.17 1.7907L5.115 1.6957C4.89 1.3007 4.38 1.1607 3.985 1.3957L3.12 1.8907C2.665 2.1507 2.51 2.7357 2.77 3.1907C3.225 3.9707 2.855 4.6107 1.95 4.6107C1.43 4.6107 1 5.0357 1 5.5607V6.4407C1 6.9607 1.425 7.3907 1.95 7.3907C2.855 7.3907 3.225 8.0307 2.77 8.8157C2.51 9.2707 2.665 9.8507 3.12 10.1107L3.985 10.6057C4.38 10.8407 4.89 10.7007 5.125 10.3057L5.18 10.2107C5.63 9.4257 6.37 9.4257 6.825 10.2107L6.88 10.3057C7.115 10.7007 7.625 10.8407 8.02 10.6057L8.885 10.1107C9.34 9.8507 9.495 9.2657 9.235 8.8157C8.78 8.0307 9.15 7.3907 10.055 7.3907C10.575 7.3907 11.005 6.9657 11.005 6.4407V5.5607C11 5.0407 10.575 4.6107 10.05 4.6107ZM6 7.6257C5.105 7.6257 4.375 6.8957 4.375 6.0007C4.375 5.1057 5.105 4.3757 6 4.3757C6.895 4.3757 7.625 5.1057 7.625 6.0007C7.625 6.8957 6.895 7.6257 6 7.6257Z" fill="#9675CE"/>
  </svg>
)

export const AccountIcon: React.FC<IconProps> = ({
  className = "", 
  size = 24,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} 
    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M13 15C13 16.1046 13 17 9 17C5 17 5 16.1046 5 15C5 13.8954 6.79086 13 9 13C11.2091 13 13 13.8954 13 15Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M19 12H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M19 9H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M19 15H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const SearchInputIc: React.FC<IconProps> = ({
  className = "", 
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} 
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_55565_36843" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="1" y="1" width="17" height="17">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.66602 1.66675H17.8967V17.8976H1.66602V1.66675Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_55565_36843)">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.78185 2.91675C5.99602 2.91675 2.91602 5.99591 2.91602 9.78175C2.91602 13.5676 5.99602 16.6476 9.78185 16.6476C13.5668 16.6476 16.6468 13.5676 16.6468 9.78175C16.6468 5.99591 13.5668 2.91675 9.78185 2.91675ZM9.78185 17.8976C5.30685 17.8976 1.66602 14.2567 1.66602 9.78175C1.66602 5.30675 5.30685 1.66675 9.78185 1.66675C14.2568 1.66675 17.8968 5.30675 17.8968 9.78175C17.8968 14.2567 14.2568 17.8976 9.78185 17.8976Z" fill="#A1A1AA"/>
    </g>
    <mask id="mask1_55565_36843" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="14" y="14" width="5" height="5">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.3652 14.7559H18.5519V18.9348H14.3652V14.7559Z" fill="white"/>
    </mask>
    <g mask="url(#mask1_55565_36843)">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.9271 18.9348C17.7679 18.9348 17.6079 18.874 17.4854 18.7523L14.5488 15.824C14.3046 15.5798 14.3038 15.184 14.5479 14.9398C14.7913 14.694 15.1871 14.6957 15.4321 14.9382L18.3688 17.8673C18.6129 18.1115 18.6138 18.5065 18.3696 18.7507C18.2479 18.874 18.0871 18.9348 17.9271 18.9348Z" fill="#A1A1AA"/>
    </g>
  </svg>
)

export const WidgetIc : React.FC<IconProps> = ({
  className = "", 
  size = 20,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    className={className}  viewBox="0 0 24 24">
    <path fill="#A8A8B0" fillRule="evenodd" d="M1.75 6.5a4.75 4.75 0 0 1 9.5 0v2.731c0 .242.001.495-.06.722a1.75 1.75 0 0 1-1.237 1.237c-.227.061-.48.06-.722.06H6.5A4.75 4.75 0 0 1 1.75 6.5M6.5 3.25a3.25 3.25 0 1 0 0 6.5h2.667c.161 0 .258 0 .33-.003l.07-.006a.25.25 0 0 0 .174-.174l.006-.07a8 8 0 0 0 .003-.33V6.5A3.25 3.25 0 0 0 6.5 3.25m8.27 9.5h2.73a4.75 4.75 0 1 1-4.75 4.75v-2.731c0-.242-.001-.495.06-.722a1.75 1.75 0 0 1 1.237-1.237c.227-.061.48-.06.722-.06m-.337 1.51a.25.25 0 0 0-.174.173l-.005.07a8 8 0 0 0-.004.33V17.5a3.25 3.25 0 1 0 3.25-3.25h-2.667c-.162 0-.258 0-.33.004zm-4.936.001a8 8 0 0 0-.596-.011H6.5a3.25 3.25 0 1 0 3.25 3.25v-2.4c0-.292 0-.467-.011-.596a.6.6 0 0 0-.018-.12a.25.25 0 0 0-.104-.105a.6.6 0 0 0-.121-.018m.224.119v.002zm-.102-1.614c.213.018.446.057.676.175c.33.167.598.435.765.765c.118.23.158.463.175.676c.016.198.016.434.016.692V17.5a4.75 4.75 0 1 1-4.75-4.75h2.426c.258 0 .494 0 .692.016M12.75 6.5a4.75 4.75 0 1 1 4.75 4.75h-2.885c-.104 0-.212 0-.31-.011a1.75 1.75 0 0 1-1.544-1.543a3 3 0 0 1-.011-.311zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v2.999l.002.03a.25.25 0 0 0 .25.22l.14.001H17.5a3.25 3.25 0 0 0 0-6.5" clipRule="evenodd"/>
  </svg>
)

export const DangerIc: React.FC<IconProps> = ({
  className = "", 
  size = 20,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 24 24">
    <g fill="none">
      <circle cx="12" cy="12" r="10" stroke="#A8A8B0" strokeWidth="1.5"/>
      <path stroke="#A8A8B0" strokeLinecap="round" strokeWidth="1.5" d="M12 7v6"/>
      <circle cx="12" cy="16" r="1" fill="#A8A8B0"/>
    </g>
  </svg>
)

export const GlobalIc:React.FC<IconProps> = ({
  className = "", 
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00004 1.33398C7.20404 1.33398 6.3495 2.47469 5.82817 4.27669C5.77217 4.47069 5.92368 4.66732 6.12634 4.66732H9.87374C10.0757 4.66732 10.2266 4.47069 10.1706 4.27669C9.64995 2.47469 8.79604 1.33398 8.00004 1.33398ZM4.70707 2.27799C4.64513 2.27038 4.57897 2.28263 4.51697 2.32096C3.74163 2.79896 3.07219 3.43243 2.54952 4.17643C2.40419 4.3831 2.54295 4.66732 2.79561 4.66732H4.1003C4.24163 4.66732 4.36321 4.56704 4.39587 4.42904C4.54587 3.79837 4.73374 3.21917 4.95707 2.70117C5.04407 2.50067 4.89288 2.30084 4.70707 2.27799ZM11.293 2.27799C11.1072 2.30087 10.9552 2.50147 11.0417 2.70247C11.265 3.21981 11.4549 3.79967 11.6042 4.43034C11.6375 4.56767 11.7584 4.66732 11.8998 4.66732H13.2045C13.4571 4.66732 13.5959 4.3831 13.4506 4.17643C12.9279 3.43243 12.2584 2.79963 11.4831 2.32096C11.4211 2.28263 11.355 2.27037 11.293 2.27799ZM1.87504 6.00065C1.73704 6.00065 1.61159 6.09194 1.57426 6.22461C1.41759 6.79061 1.33337 7.38532 1.33337 8.00065C1.33337 8.61598 1.41759 9.21069 1.57426 9.77669C1.61093 9.90936 1.73704 10.0007 1.87504 10.0007H3.78259C3.96393 10.0007 4.10268 9.84668 4.08468 9.66602C4.03134 9.13135 4.00004 8.57665 4.00004 8.00065C4.00004 7.42465 4.03134 6.86995 4.08468 6.33529C4.10268 6.15462 3.96393 6.00065 3.78259 6.00065H1.87504ZM5.74093 6.00065C5.58493 6.00065 5.4523 6.11421 5.43363 6.26888C5.36963 6.81755 5.33337 7.39665 5.33337 8.00065C5.33337 8.60465 5.36963 9.18376 5.43363 9.73242C5.4523 9.88709 5.58493 10.0007 5.74093 10.0007H10.2592C10.4152 10.0007 10.5484 9.88709 10.5664 9.73242C10.6311 9.18376 10.6667 8.60465 10.6667 8.00065C10.6667 7.39665 10.6304 6.81755 10.5664 6.26888C10.5478 6.11421 10.4152 6.00065 10.2592 6.00065H5.74093ZM12.2175 6.00065C12.0362 6.00065 11.8974 6.15462 11.9154 6.33529C11.9687 6.86995 12 7.42465 12 8.00065C12 8.57665 11.9687 9.13135 11.9154 9.66602C11.8974 9.84668 12.0362 10.0007 12.2175 10.0007H14.125C14.263 10.0007 14.3885 9.90936 14.4258 9.77669C14.5825 9.21069 14.6667 8.61598 14.6667 8.00065C14.6667 7.38532 14.5825 6.79061 14.4258 6.22461C14.3892 6.09194 14.263 6.00065 14.125 6.00065H12.2175ZM2.79561 11.334C2.54295 11.334 2.40419 11.6182 2.54952 11.8249C3.07219 12.5689 3.74163 13.2017 4.51697 13.6803C4.76497 13.8337 5.07371 13.5668 4.95837 13.2988C4.73504 12.7815 4.54521 12.2016 4.39587 11.571C4.36254 11.4336 4.24163 11.334 4.1003 11.334H2.79561ZM6.12634 11.334C5.92434 11.334 5.77347 11.5306 5.82947 11.7246C6.35013 13.5266 7.20404 14.6673 8.00004 14.6673C8.79604 14.6673 9.65058 13.5266 10.1719 11.7246C10.2279 11.5306 10.0764 11.334 9.87374 11.334H6.12634ZM11.8998 11.3353C11.7584 11.3346 11.6369 11.4343 11.6042 11.5723C11.4542 12.2029 11.2663 12.7821 11.043 13.3001C10.9277 13.5681 11.2344 13.8343 11.4831 13.6816C12.2584 13.2036 12.9279 12.5702 13.4506 11.8262C13.5959 11.6195 13.4571 11.3353 13.2045 11.3353H11.8998Z" fill="#A8A8B0"/>
  </svg>
)

export const ClockIc:React.FC<IconProps> = ({
  className = "", 
  size = 14,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99996 1.16602C3.78579 1.16602 1.16663 3.78518 1.16663 6.99935C1.16663 10.2135 3.78579 12.8327 6.99996 12.8327C10.2141 12.8327 12.8333 10.2135 12.8333 6.99935C12.8333 3.78518 10.2141 1.16602 6.99996 1.16602ZM9.53746 9.08185C9.45579 9.22185 9.30996 9.29768 9.15829 9.29768C9.08246 9.29768 9.00663 9.28018 8.93663 9.23352L7.12829 8.15435C6.67913 7.88602 6.34663 7.29685 6.34663 6.77768V4.38602C6.34663 4.14685 6.54496 3.94852 6.78413 3.94852C7.02329 3.94852 7.22163 4.14685 7.22163 4.38602V6.77768C7.22163 6.98768 7.39663 7.29685 7.57746 7.40185L9.38579 8.48102C9.59579 8.60352 9.66579 8.87185 9.53746 9.08185Z" fill="#71717A"/>
  </svg>
)

export const ArrowGreen:React.FC<IconProps> = ({
  className=''
}) => (
  <svg width="13" height="12" className={className} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 9L9.5 3M9.5 3H5M9.5 3V7.5" stroke="#10793C" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
export const ChartSquare:React.FC<IconProps> = ({
  className='',
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_55587_115669)">
    <path d="M1 6C1 3.64298 1 2.46447 1.73223 1.73223C2.46447 1 3.64298 1 6 1C8.35702 1 9.53553 1 10.2678 1.73223C11 2.46447 11 3.64298 11 6C11 8.35702 11 9.53553 10.2678 10.2678C9.53553 11 8.35702 11 6 11C3.64298 11 2.46447 11 1.73223 10.2678C1 9.53553 1 8.35702 1 6Z" stroke="#71717A"/>
    <path d="M3.5 9V4.5" stroke="#71717A" strokeLinecap="round"/>
    <path d="M6 9V3" stroke="#71717A" strokeLinecap="round"/>
    <path d="M8.5 9V6.5" stroke="#71717A" strokeLinecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_55587_115669">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const SortArrowDown:React.FC<IconProps> = ({
  className='',
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2.66602L8 13.3327M8 13.3327L12 9.33268M8 13.3327L4 9.33268" stroke="#11181C" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const SortArrowUp:React.FC<IconProps> = ({
  className='',
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 13.3327L8 2.66602M8 2.66602L12 6.66602M8 2.66602L4 6.66602" stroke="#11181C" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

)

export const ArrowRight4: React.FC<IconProps> = ({
  className = '',
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.25 6.75L15.5 12L9.25 17.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 12H14.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRight5: React.FC<IconProps> = ({
  className = '',
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 5.75L15.75 12L8.5 18.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 12H14.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIc :React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.46484 13.5356L13.5359 6.46458" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.5359 13.5354L6.46484 6.46436" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const LogoPartnerIc:React.FC<IconProps> = ({
  className='',
}) => (
  <svg width="121" height="36" className={className} viewBox="0 0 121 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3127 34.4467C12.2565 34.4467 10.3522 34.1125 8.6099 33.444C6.86766 32.7754 5.35838 31.8334 4.06182 30.6077C2.76527 29.3922 1.77259 27.964 1.06354 26.323C0.354485 24.6821 -4.19617e-05 22.8993 -4.19617e-05 20.9545C-4.19617e-05 19.0096 0.354485 17.1965 1.06354 15.5758C1.77259 13.9449 2.76527 12.5268 4.06182 11.3113C5.34825 10.0958 6.85753 9.15375 8.58964 8.48522C10.3116 7.81668 12.2058 7.48242 14.2722 7.48242C16.3386 7.48242 18.2227 7.8167 19.9548 8.4751C21.6768 9.13351 23.1962 10.0755 24.4826 11.291C25.769 12.5066 26.7718 13.9348 27.4809 15.5758C28.1899 17.2167 28.5445 19.0096 28.5445 20.9747C28.5445 22.9398 28.1899 24.7023 27.4809 26.3534C26.7718 28.0045 25.769 29.4429 24.4826 30.6584C23.186 31.8739 21.6869 32.8159 19.9548 33.4743C18.2227 34.1327 16.3487 34.467 14.3127 34.467V34.4467ZM14.2823 29.3416C15.4472 29.3416 16.5209 29.139 17.5035 28.7237C18.486 28.3185 19.347 27.731 20.0966 26.9713C20.836 26.2116 21.4235 25.3303 21.8287 24.3275C22.2339 23.3247 22.4466 22.2004 22.4466 20.9545C22.4466 19.7085 22.244 18.5943 21.8287 17.5814C21.4235 16.5786 20.8462 15.6872 20.0966 14.9376C19.3571 14.1779 18.486 13.6006 17.5035 13.1853C16.5209 12.7801 15.4472 12.5674 14.2823 12.5674C13.1175 12.5674 12.0336 12.7699 11.0409 13.1853C10.0483 13.5904 9.18727 14.1779 8.44783 14.9376C7.71852 15.6973 7.14115 16.5786 6.73597 17.5814C6.3308 18.5842 6.11808 19.7085 6.11808 20.9545C6.11808 22.2004 6.32067 23.3146 6.73597 24.3275C7.14115 25.3303 7.71852 26.2217 8.44783 26.9713C9.17714 27.731 10.0483 28.3084 11.0409 28.7237C12.0336 29.1288 13.1175 29.3416 14.2823 29.3416Z" fill="black"/>
    <path d="M30.7629 34.001V7.91797H35.7566L51.1431 26.6978H48.7222V7.91797H54.6782V34.001H49.6845L34.298 15.2212H36.7189V34.001H30.7629Z" fill="black"/>
    <path d="M58.1324 34.001V7.91797H64.21V29.0782H77.2161V34.001H58.1425H58.1324Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M105.831 7.99903L105.761 8.32319H109.701V22.3827C109.731 27.3461 105.568 30.4457 100.422 28.8959C97.0088 27.8627 96.0566 25.2189 95.9148 22.0991C95.8135 19.6782 95.854 17.2269 95.9148 14.7654C95.9351 14.0057 95.9452 13.2359 95.9553 12.4762L89.0674 23.9629C90.7691 39.7748 115.89 39.5722 116.589 22.8791V8.18136H120.448C120.448 8.00916 120.296 7.83698 120.164 7.68504C120.134 7.64452 120.094 7.61413 120.073 7.58374C119.06 6.38848 117.936 5.24385 116.812 4.09923C115.667 2.93436 114.522 1.75937 113.489 0.543843C113.165 0.199445 112.902 0.483067 112.659 0.74643C112.618 0.786948 112.588 0.82745 112.547 0.857838C111.423 1.97207 110.369 3.13695 109.316 4.31196C108.181 5.568 107.057 6.82404 105.842 8.00917L105.831 7.99903Z" fill="#006FEE"/>
    <path d="M79.333 34.001V23.3449L80.7106 26.9915L69.1935 7.91797H75.6358L84.4281 22.5245H80.741L89.5738 7.91797H95.4589L84.0229 26.9915L85.4005 23.3449V34.001H79.333Z" fill="black"/>
  </svg>
)

export const LogoCreatorAuthIc:React.FC<IconProps> = ({
  className='',

}) => (
  <svg width="121" height="36" className={className}  viewBox="0 0 121 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3127 34.062C12.2565 34.062 10.3522 33.7277 8.6099 33.0592C6.86766 32.3906 5.35838 31.4486 4.06182 30.223C2.76527 29.0074 1.77259 27.5792 1.06354 25.9382C0.354485 24.2973 -4.19617e-05 22.5145 -4.19617e-05 20.5697C-4.19617e-05 18.6249 0.354485 16.8117 1.06354 15.191C1.77259 13.5602 2.76527 12.1421 4.06182 10.9266C5.34825 9.71103 6.85753 8.76899 8.58964 8.10045C10.3116 7.43191 12.2058 7.09766 14.2722 7.09766C16.3386 7.09766 18.2227 7.43193 19.9548 8.09034C21.6768 8.74875 23.1962 9.69075 24.4826 10.9063C25.769 12.1218 26.7718 13.55 27.4809 15.191C28.1899 16.832 28.5445 18.6249 28.5445 20.5899C28.5445 22.555 28.1899 24.3176 27.4809 25.9686C26.7718 27.6197 25.769 29.0581 24.4826 30.2736C23.186 31.4891 21.6869 32.4311 19.9548 33.0896C18.2227 33.748 16.3487 34.0822 14.3127 34.0822V34.062ZM14.2823 28.9568C15.4472 28.9568 16.5209 28.7542 17.5035 28.3389C18.486 27.9337 19.347 27.3462 20.0966 26.5865C20.836 25.8268 21.4235 24.9456 21.8287 23.9428C22.2339 22.94 22.4466 21.8156 22.4466 20.5697C22.4466 19.3238 22.244 18.2095 21.8287 17.1966C21.4235 16.1938 20.8462 15.3024 20.0966 14.5528C19.3571 13.7931 18.486 13.2158 17.5035 12.8005C16.5209 12.3953 15.4472 12.1826 14.2823 12.1826C13.1175 12.1826 12.0336 12.3852 11.0409 12.8005C10.0483 13.2057 9.18727 13.7931 8.44783 14.5528C7.71852 15.3125 7.14115 16.1938 6.73597 17.1966C6.3308 18.1994 6.11808 19.3238 6.11808 20.5697C6.11808 21.8156 6.32067 22.9298 6.73597 23.9428C7.14115 24.9456 7.71852 25.8369 8.44783 26.5865C9.17714 27.3462 10.0483 27.9236 11.0409 28.3389C12.0336 28.7441 13.1175 28.9568 14.2823 28.9568Z" fill="black"/>
    <path d="M30.7629 33.6163V7.5332H35.7566L51.1431 26.313H48.7222V7.5332H54.6782V33.6163H49.6845L34.298 14.8364H36.7189V33.6163H30.7629Z" fill="black"/>
    <path d="M58.1324 33.6163V7.5332H64.21V28.6934H77.2161V33.6163H58.1425H58.1324Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M105.831 7.61426L105.761 7.93842H109.701V21.9979C109.731 26.9613 105.568 30.0609 100.422 28.5111C97.0088 27.4779 96.0566 24.8342 95.9148 21.7143C95.8135 19.2934 95.854 16.8421 95.9148 14.3807C95.9351 13.621 95.9452 12.8512 95.9553 12.0915L89.0674 23.5781C90.7691 39.39 115.89 39.1875 116.589 22.4943V7.7966H120.448C120.448 7.6244 120.296 7.45221 120.164 7.30027C120.134 7.25975 120.094 7.22936 120.073 7.19898C119.06 6.00371 117.936 4.85908 116.812 3.71446C115.667 2.54959 114.522 1.3746 113.489 0.159078C113.165 -0.18532 112.902 0.0983014 112.659 0.361665C112.618 0.402182 112.588 0.442685 112.547 0.473073C111.423 1.5873 110.369 2.75219 109.316 3.92719C108.181 5.18323 107.057 6.43927 105.842 7.6244L105.831 7.61426Z" fill="url(#paint0_linear_55107_1430)"/>
    <path d="M79.333 33.6163V22.9602L80.7106 26.6067L69.1935 7.5332H75.6358L84.4281 22.1397H80.741L89.5738 7.5332H95.4589L84.0229 26.6067L85.4005 22.9602V33.6163H79.333Z" fill="black"/>
    <defs>
    <linearGradient id="paint0_linear_55107_1430" x1="89.6002" y1="55.2152" x2="122.4" y2="0.0152379" gradientUnits="userSpaceOnUse">
    <stop stopColor="#B39DDB"/>
    <stop offset="1" stopColor="#9675CE"/>
    </linearGradient>
    </defs>
  </svg>
)

export const RefreshIc:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.06586 9.44444H2.31586H3.06586ZM3.06586 10.8333L2.53762 11.3657C2.83003 11.6559 3.30169 11.6559 3.5941 11.3657L3.06586 10.8333ZM4.99394 9.97685C5.28799 9.68511 5.28985 9.21024 4.99811 8.9162C4.70637 8.62216 4.2315 8.6203 3.93746 8.91204L4.99394 9.97685ZM2.19426 8.91204C1.90022 8.6203 1.42535 8.62216 1.13361 8.9162C0.841866 9.21024 0.843731 9.68511 1.13777 9.97685L2.19426 8.91204ZM15.4058 6.22612C15.6228 6.57899 16.0847 6.68918 16.4375 6.47225C16.7904 6.25532 16.9006 5.79341 16.6837 5.44054L15.4058 6.22612ZM10.0651 2.5V1.75C5.79086 1.75 2.31586 5.18938 2.31586 9.44444H3.06586H3.81586C3.81586 6.02889 6.60816 3.25 10.0651 3.25V2.5ZM3.06586 9.44444H2.31586L2.31586 10.8333H3.06586H3.81586L3.81586 9.44444L3.06586 9.44444ZM3.06586 10.8333L3.5941 11.3657L4.99394 9.97685L4.4657 9.44444L3.93746 8.91204L2.53762 10.3009L3.06586 10.8333ZM3.06586 10.8333L3.5941 10.3009L2.19426 8.91204L1.66602 9.44444L1.13777 9.97685L2.53762 11.3657L3.06586 10.8333ZM16.0447 5.83333L16.6837 5.44054C15.3231 3.22738 12.867 1.75 10.0651 1.75V2.5V3.25C12.3281 3.25 14.3087 4.44155 15.4058 6.22612L16.0447 5.83333Z" fill="#A8A8B0"/>
    <path d="M16.9289 9.16663L17.4561 8.63321C17.164 8.34443 16.6938 8.34443 16.4017 8.63321L16.9289 9.16663ZM14.9965 10.0221C14.7019 10.3133 14.6991 10.7881 14.9903 11.0827C15.2815 11.3773 15.7563 11.3801 16.0509 11.0889L14.9965 10.0221ZM17.8069 11.0889C18.1015 11.3801 18.5763 11.3773 18.8675 11.0827C19.1587 10.7881 19.1559 10.3133 18.8613 10.0221L17.8069 11.0889ZM4.53864 13.7727C4.32111 13.4203 3.85901 13.3108 3.50651 13.5284C3.15402 13.7459 3.04461 14.208 3.26214 14.5605L4.53864 13.7727ZM9.90293 17.5V18.25C14.1892 18.25 17.6789 14.8133 17.6789 10.5555H16.9289H16.1789C16.1789 13.9684 13.3773 16.75 9.90293 16.75V17.5ZM16.9289 10.5555H17.6789V9.16663H16.9289H16.1789V10.5555H16.9289ZM16.9289 9.16663L16.4017 8.63321L14.9965 10.0221L15.5237 10.5555L16.0509 11.0889L17.4561 9.70004L16.9289 9.16663ZM16.9289 9.16663L16.4017 9.70004L17.8069 11.0889L18.3341 10.5555L18.8613 10.0221L17.4561 8.63321L16.9289 9.16663ZM3.90039 14.1666L3.26214 14.5605C4.62804 16.7738 7.09266 18.25 9.90293 18.25V17.5V16.75C7.62886 16.75 5.63984 15.5571 4.53864 13.7727L3.90039 14.1666Z" fill="#A8A8B0"/>
  </svg>
)

export const OnlyFansIc:React.FC<IconProps> = ({
  className='',
  size = 14,
  fill="#71717A"
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.50001 6.30039V4.90039C3.50001 2.96739 5.06701 1.40039 7 1.40039C8.933 1.40039 10.5 2.96739 10.5 4.90039V6.30039C11.2732 6.30039 11.9 6.92719 11.9 7.70039V11.2004C11.9 11.9736 11.2732 12.6004 10.5 12.6004H3.5C2.72681 12.6004 2.10001 11.9736 2.10001 11.2004V7.70039C2.10001 6.92719 2.72681 6.30039 3.50001 6.30039ZM9.1 4.90039V6.30039H4.9V4.90039C4.9 3.74059 5.84021 2.80039 7 2.80039C8.1598 2.80039 9.1 3.74059 9.1 4.90039Z" fill={fill}/>
  </svg>
)

export const HeartIc:React.FC<IconProps> = ({
  className='',
  size = 14,
  fill="#D4D4D8",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.09072 1.13281C2.16272 1.13281 0.600098 2.69544 0.600098 4.62344C0.600098 7.97938 4.49288 11.186 6.31156 12.6141C6.31329 12.6155 6.31502 12.6168 6.31676 12.6182C6.32923 12.628 6.34617 12.6419 6.35843 12.6516L6.35947 12.6505C6.54399 12.7899 6.76883 12.8656 7.0001 12.8661C7.23173 12.8658 7.45696 12.7902 7.64176 12.6505V12.6516C7.64535 12.6487 7.65066 12.645 7.65426 12.6422C7.65701 12.64 7.66089 12.6371 7.66364 12.6349C7.66713 12.6318 7.6706 12.6287 7.67406 12.6255C9.48709 11.2026 13.4001 7.98739 13.4001 4.62344C13.4001 2.69544 11.8375 1.13281 9.90947 1.13281C8.06681 1.13281 7.0001 2.73281 7.0001 2.73281C7.0001 2.73281 5.93339 1.13281 4.09072 1.13281Z" fill={fill}/>
  </svg>
)


export const IcModalSuccess :React.FC<IconProps> = ({
  className='',
  size = 32,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16.5" r="14" fill="#E8FAF0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M24.3337 16C24.3337 20.6023 20.6027 24.3333 16.0003 24.3333C11.398 24.3333 7.66699 20.6023 7.66699 16C7.66699 11.3976 11.398 7.66663 16.0003 7.66663C20.6027 7.66663 24.3337 11.3976 24.3337 16ZM19.3589 13.4747C19.603 13.7188 19.603 14.1145 19.3589 14.3586L15.1923 18.5252C14.9482 18.7693 14.5525 18.7693 14.3084 18.5252L12.6417 16.8586C12.3976 16.6145 12.3976 16.2188 12.6417 15.9747C12.8858 15.7306 13.2815 15.7306 13.5256 15.9747L14.7503 17.1994L16.6127 15.337L18.4751 13.4747C18.7191 13.2306 19.1149 13.2306 19.3589 13.4747Z" fill="#10793C"/>
  </svg>

)


export const IcReddit :React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_56582_16671)">
    <path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#A8A8B0"/>
    <path d="M13.3335 7.99954C13.3335 7.35392 12.8095 6.82995 12.1639 6.82995C11.8458 6.82995 11.5651 6.95158 11.3592 7.15743C10.5639 6.58667 9.45982 6.2124 8.24344 6.16562L8.77677 3.66737L10.5078 4.03229C10.5265 4.47205 10.8914 4.82761 11.3405 4.82761C11.799 4.82761 12.1733 4.45334 12.1733 3.99486C12.1733 3.53638 11.799 3.16211 11.3405 3.16211C11.013 3.16211 10.7323 3.34924 10.6013 3.62995L8.66449 3.21825C8.60835 3.20889 8.55221 3.21825 8.50543 3.24632C8.45865 3.27439 8.43058 3.32117 8.41186 3.37731L7.82239 6.16562C6.57794 6.20305 5.46449 6.56796 4.65982 7.15743C4.45397 6.96094 4.16391 6.82995 3.85514 6.82995C3.20952 6.82995 2.68555 7.35392 2.68555 7.99954C2.68555 8.47673 2.96625 8.87907 3.37794 9.0662C3.35923 9.17848 3.34987 9.30012 3.34987 9.42176C3.34987 11.2183 5.43642 12.6685 8.01888 12.6685C10.6013 12.6685 12.6879 11.2183 12.6879 9.42176C12.6879 9.30012 12.6785 9.18784 12.6598 9.07556C13.0434 8.88842 13.3335 8.47673 13.3335 7.99954ZM5.3335 8.83229C5.3335 8.37381 5.70777 7.99954 6.16625 7.99954C6.62473 7.99954 6.999 8.37381 6.999 8.83229C6.999 9.29076 6.62473 9.66503 6.16625 9.66503C5.70777 9.66503 5.3335 9.29076 5.3335 8.83229ZM9.98379 11.0311C9.41303 11.6019 8.32765 11.6393 8.00952 11.6393C7.69139 11.6393 6.59666 11.5925 6.03525 11.0311C5.95104 10.9469 5.95104 10.8066 6.03525 10.7223C6.11946 10.6381 6.25982 10.6381 6.34403 10.7223C6.69958 11.0779 7.46683 11.2089 8.01888 11.2089C8.57093 11.2089 9.32882 11.0779 9.69373 10.7223C9.77794 10.6381 9.9183 10.6381 10.0025 10.7223C10.068 10.8159 10.068 10.9469 9.98379 11.0311ZM9.83408 9.66503C9.37561 9.66503 9.00134 9.29076 9.00134 8.83229C9.00134 8.37381 9.37561 7.99954 9.83408 7.99954C10.2926 7.99954 10.6668 8.37381 10.6668 8.83229C10.6668 9.29076 10.2926 9.66503 9.83408 9.66503Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_56582_16671">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const IcAnotherSoc :React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0687 3.66824C10.6936 3.0434 11.7066 3.0434 12.3315 3.66824C12.9563 4.29308 12.9563 5.30614 12.3315 5.93098L9.93145 8.33098C9.30661 8.95582 8.29355 8.95582 7.66871 8.33098C7.35629 8.01856 6.84976 8.01856 6.53734 8.33098C6.22492 8.6434 6.22492 9.14993 6.53734 9.46235C7.78702 10.712 9.81315 10.712 11.0628 9.46235L13.4628 7.06235C14.7125 5.81267 14.7125 3.78655 13.4628 2.53687C12.2131 1.28719 10.187 1.28719 8.93734 2.53687L7.73734 3.73687C7.42492 4.04929 7.42492 4.55582 7.73734 4.86824C8.04976 5.18066 8.55629 5.18066 8.86871 4.86824L10.0687 3.66824Z" fill="#71717A"/>
    <path d="M6.06873 7.66824C6.69356 7.0434 7.70663 7.0434 8.33147 7.66824C8.64389 7.98066 9.15042 7.98066 9.46284 7.66824C9.77526 7.35582 9.77526 6.84929 9.46284 6.53687C8.21316 5.28719 6.18703 5.28719 4.93736 6.53687L2.53736 8.93687C1.28768 10.1865 1.28768 12.2127 2.53736 13.4624C3.78703 14.712 5.81316 14.712 7.06284 13.4624L8.26284 12.2624C8.57526 11.9499 8.57526 11.4434 8.26284 11.131C7.95042 10.8186 7.44389 10.8186 7.13147 11.131L5.93147 12.331C5.30663 12.9558 4.29357 12.9558 3.66873 12.331C3.04389 11.7061 3.04389 10.6931 3.66873 10.0682L6.06873 7.66824Z" fill="#71717A"/>
  </svg>
)

export const IcTg :React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#A8A8B0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.62118 7.91596C5.95334 6.89987 7.50848 6.23001 8.2866 5.90636C10.5083 4.98228 10.9699 4.82176 11.2708 4.81646C11.337 4.8153 11.485 4.8317 11.5808 4.90947C11.6618 4.97515 11.684 5.06386 11.6947 5.12612C11.7053 5.18839 11.7186 5.33023 11.7081 5.44106C11.5877 6.70604 11.0667 9.77584 10.8017 11.1926C10.6896 11.7921 10.4687 11.9932 10.255 12.0128C9.7904 12.0556 9.43762 11.7058 8.98766 11.4109C8.28356 10.9493 7.88578 10.662 7.20233 10.2116C6.41248 9.6911 6.9245 9.40503 7.37464 8.9375C7.49244 8.81514 9.53937 6.95331 9.57898 6.78441C9.58394 6.76329 9.58854 6.68455 9.54176 6.64297C9.49498 6.60139 9.42595 6.61561 9.37612 6.62692C9.30551 6.64295 8.18069 7.38641 6.00168 8.8573C5.6824 9.07654 5.39321 9.18336 5.13411 9.17776C4.84847 9.17159 4.29901 9.01626 3.89054 8.88348C3.38954 8.72062 2.99136 8.63452 3.02603 8.35794C3.04409 8.21388 3.24247 8.06655 3.62118 7.91596Z" fill="white"/>
  </svg>
)

export const IcTikTok :React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0169 5.45598C12.0458 6.1941 13.3062 6.62839 14.6676 6.62839V3.99941C14.41 3.99947 14.153 3.97251 13.9009 3.91891V5.98829C12.5397 5.98829 11.2794 5.554 10.2502 4.81594V10.1809C10.2502 12.8648 8.08228 15.0403 5.40814 15.0403C4.41036 15.0403 3.48296 14.7376 2.71256 14.2184C3.59184 15.1206 4.81805 15.6803 6.17465 15.6803C8.84895 15.6803 11.017 13.5048 11.017 10.8209L11.0169 5.45598ZM11.9627 2.80367C11.4368 2.22716 11.0916 1.48212 11.0169 0.658455V0.320312H10.2904C10.4732 1.36719 11.097 2.26158 11.9627 2.80367ZM4.40396 12.1589C4.11017 11.7723 3.95141 11.2994 3.95212 10.8132C3.95212 9.58568 4.94373 8.59042 6.1671 8.59042C6.39509 8.59036 6.62172 8.6254 6.839 8.69459V6.00685C6.58508 5.97193 6.32881 5.9571 6.07265 5.96254V8.05454C5.85521 7.98535 5.62848 7.95021 5.40043 7.95043C4.17706 7.95043 3.18551 8.94558 3.18551 10.1732C3.18551 11.0413 3.68115 11.7928 4.40396 12.1589Z" fill="#A8A8B0"/>
    <path d="M10.2502 4.81594C11.2794 5.554 12.5397 5.98829 13.9009 5.98829V3.91891C13.1411 3.75648 12.4684 3.35794 11.9627 2.80367C11.097 2.26158 10.4732 1.36719 10.2904 0.320312H8.38197V10.8207C8.37765 12.0449 7.38774 13.0361 6.167 13.0361C5.44763 13.0361 4.8087 12.6919 4.40396 12.1589C3.68115 11.7928 3.18551 11.0413 3.18551 10.1732C3.18551 8.94558 4.17706 7.95043 5.40043 7.95043C5.63482 7.95043 5.86074 7.98706 6.07265 8.05454V5.96254C3.44549 6.01701 1.33252 8.17134 1.33252 10.8208C1.33252 12.1434 1.85861 13.3423 2.71256 14.2184C3.48296 14.7376 4.41036 15.0403 5.40814 15.0403C8.08228 15.0403 10.2502 12.8648 10.2502 10.1809V4.81594Z" fill="#A8A8B0"/>
  </svg>
)

export const IcYoutube :React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8406 4.79922C15.8406 4.79922 15.6844 3.69609 15.2031 3.21172C14.5938 2.57422 13.9125 2.57109 13.6 2.53359C11.3625 2.37109 8.00313 2.37109 8.00313 2.37109H7.99687C7.99687 2.37109 4.6375 2.37109 2.4 2.53359C2.0875 2.57109 1.40625 2.57422 0.796875 3.21172C0.315625 3.69609 0.1625 4.79922 0.1625 4.79922C0.1625 4.79922 0 6.09609 0 7.38984V8.60234C0 9.89609 0.159375 11.193 0.159375 11.193C0.159375 11.193 0.315625 12.2961 0.79375 12.7805C1.40313 13.418 2.20313 13.3961 2.55938 13.4648C3.84063 13.5867 8 13.6242 8 13.6242C8 13.6242 11.3625 13.618 13.6 13.4586C13.9125 13.4211 14.5938 13.418 15.2031 12.7805C15.6844 12.2961 15.8406 11.193 15.8406 11.193C15.8406 11.193 16 9.89922 16 8.60234V7.38984C16 6.09609 15.8406 4.79922 15.8406 4.79922ZM6.34688 10.0742V5.57734L10.6687 7.83359L6.34688 10.0742Z" fill="#A8A8B0"/>
  </svg>
)

export const SuccesAlertIc:React.FC<IconProps> = ({
  className='',
  size = 36,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#E8FAF0"/>
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#D1F2E0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M24.6668 18C24.6668 21.6819 21.6821 24.6667 18.0002 24.6667C14.3183 24.6667 11.3335 21.6819 11.3335 18C11.3335 14.3181 14.3183 11.3334 18.0002 11.3334C21.6821 11.3334 24.6668 14.3181 24.6668 18ZM20.687 15.9798C20.8823 16.1751 20.8823 16.4917 20.687 16.6869L17.3537 20.0203C17.1585 20.2155 16.8419 20.2155 16.6466 20.0203L15.3133 18.6869C15.118 18.4917 15.118 18.1751 15.3133 17.9798C15.5085 17.7846 15.8251 17.7846 16.0204 17.9798L17.0002 18.9596L18.4901 17.4697L19.9799 15.9798C20.1752 15.7846 20.4918 15.7846 20.687 15.9798Z" fill="#0E793C"/>
  </svg>
)

export const CheckCircleCreatorIc:React.FC<IconProps> = ({
  className='',
  size = 28,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9993 0.666504C6.65268 0.666504 0.666016 6.65317 0.666016 13.9998C0.666016 21.3465 6.65268 27.3332 13.9993 27.3332C21.346 27.3332 27.3327 21.3465 27.3327 13.9998C27.3327 6.65317 21.346 0.666504 13.9993 0.666504ZM20.3727 10.9332L12.8127 18.4932C12.626 18.6798 12.3727 18.7865 12.106 18.7865C11.8393 18.7865 11.586 18.6798 11.3993 18.4932L7.62602 14.7198C7.23935 14.3332 7.23935 13.6932 7.62602 13.3065C8.01268 12.9198 8.65268 12.9198 9.03935 13.3065L12.106 16.3732L18.9593 9.51984C19.346 9.13317 19.986 9.13317 20.3727 9.51984C20.7594 9.9065 20.7594 10.5332 20.3727 10.9332Z" fill="#B39CDB"/>
  </svg>
)

export const CheckCirclePartnerIc:React.FC<IconProps> = ({
  className='',
  size = 28,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9993 0.666504C6.65268 0.666504 0.666016 6.65317 0.666016 13.9998C0.666016 21.3465 6.65268 27.3332 13.9993 27.3332C21.346 27.3332 27.3327 21.3465 27.3327 13.9998C27.3327 6.65317 21.346 0.666504 13.9993 0.666504ZM20.3727 10.9332L12.8127 18.4932C12.626 18.6798 12.3727 18.7865 12.106 18.7865C11.8393 18.7865 11.586 18.6798 11.3993 18.4932L7.62602 14.7198C7.23935 14.3332 7.23935 13.6932 7.62602 13.3065C8.01268 12.9198 8.65268 12.9198 9.03935 13.3065L12.106 16.3732L18.9593 9.51984C19.346 9.13317 19.986 9.13317 20.3727 9.51984C20.7594 9.9065 20.7594 10.5332 20.3727 10.9332Z" fill="#338CF1"/>
  </svg>
)

export const ErrorCircleIc:React.FC<IconProps> = ({
  className='',
  size = 28,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M27.3327 13.9998C27.3327 21.3636 21.3631 27.3332 13.9993 27.3332C6.63555 27.3332 0.666016 21.3636 0.666016 13.9998C0.666016 6.63604 6.63555 0.666504 13.9993 0.666504C21.3631 0.666504 27.3327 6.63604 27.3327 13.9998ZM13.9993 21.6665C14.5516 21.6665 14.9993 21.2188 14.9993 20.6665V12.6665C14.9993 12.1142 14.5516 11.6665 13.9993 11.6665C13.4471 11.6665 12.9993 12.1142 12.9993 12.6665V20.6665C12.9993 21.2188 13.4471 21.6665 13.9993 21.6665ZM13.9993 7.33317C14.7357 7.33317 15.3327 7.93012 15.3327 8.6665C15.3327 9.40288 14.7357 9.99984 13.9993 9.99984C13.263 9.99984 12.666 9.40288 12.666 8.6665C12.666 7.93012 13.263 7.33317 13.9993 7.33317Z" fill="#F31260"/>
  </svg>
)

export const CalendarFilterIc:React.FC<IconProps> = ({
  className='',
  size = 20,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66666 1.66699V4.16699" stroke="#A8A8B0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 1.66699V4.16699" stroke="#A8A8B0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.91666 7.5752H17.0833" stroke="#A8A8B0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.5 7.08366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V7.08366C2.5 4.58366 3.75 2.91699 6.66667 2.91699H13.3333C16.25 2.91699 17.5 4.58366 17.5 7.08366Z" stroke="#A8A8B0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.0789 11.4167H13.0864" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.0789 13.9167H13.0864" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99623 11.4167H10.0037" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99623 13.9167H10.0037" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.91193 11.4167H6.91941" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.91193 13.9167H6.91941" stroke="#A8A8B0" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const LogoPartnerSidebarIc:React.FC<IconProps> = ({
  className='',
}) => (
  <svg width="76" height="22" className={className} viewBox="0 0 76 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.94548 21.2792C7.66032 21.2792 6.47012 21.0703 5.38122 20.6525C4.29231 20.2346 3.34901 19.6459 2.53867 18.8798C1.72832 18.1201 1.1079 17.2275 0.664738 16.2019C0.221579 15.1763 0 14.0621 0 12.8465C0 11.631 0.221579 10.4978 0.664738 9.48485C1.1079 8.46558 1.72832 7.57928 2.53867 6.81958C3.34268 6.05987 4.28598 5.4711 5.36855 5.05326C6.4448 4.63543 7.62866 4.42651 8.92015 4.42651C10.2116 4.42651 11.3892 4.63543 12.4718 5.04694C13.548 5.45844 14.4976 6.0472 15.3016 6.8069C16.1057 7.5666 16.7324 8.45925 17.1756 9.48485C17.6187 10.5104 17.8403 11.631 17.8403 12.8592C17.8403 14.0874 17.6187 15.1889 17.1756 16.2209C16.7324 17.2528 16.1057 18.1518 15.3016 18.9115C14.4913 19.6712 13.5543 20.2599 12.4718 20.6714C11.3892 21.0829 10.218 21.2919 8.94548 21.2919V21.2792ZM8.92649 18.0885C9.65454 18.0885 10.3256 17.9619 10.9397 17.7023C11.5538 17.4491 12.0919 17.0819 12.5604 16.607C13.0225 16.1322 13.3897 15.5815 13.643 14.9547C13.8962 14.328 14.0291 13.6252 14.0291 12.8465C14.0291 12.0678 13.9025 11.3714 13.643 10.7384C13.3897 10.1116 13.0289 9.55449 12.5604 9.086C12.0982 8.61119 11.5538 8.25035 10.9397 7.99078C10.3256 7.73755 9.65454 7.60459 8.92649 7.60459C8.19844 7.60459 7.52104 7.73122 6.90062 7.99078C6.2802 8.24401 5.74207 8.61119 5.27992 9.086C4.8241 9.56082 4.46324 10.1116 4.21001 10.7384C3.95678 11.3651 3.82383 12.0678 3.82383 12.8465C3.82383 13.6252 3.95045 14.3216 4.21001 14.9547C4.46324 15.5815 4.8241 16.1386 5.27992 16.607C5.73574 17.0819 6.2802 17.4427 6.90062 17.7023C7.52104 17.9555 8.19844 18.0885 8.92649 18.0885Z" fill="black"/>
    <path d="M19.2266 21.0006V4.69873H22.3477L31.9642 16.4361H30.4511V4.69873H34.1737V21.0006H31.0526L21.436 9.26326H22.9491V21.0006H19.2266Z" fill="black"/>
    <path d="M36.332 21.0006V4.69873H40.1305V17.9239H48.2593V21.0006H36.3384H36.332Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M66.1455 4.74939L66.1012 4.95199H68.5639V13.7392C68.5829 16.8413 65.9809 18.7785 62.7648 17.8099C60.6314 17.1642 60.0363 15.5118 59.9476 13.5619C59.8843 12.0489 59.9096 10.5168 59.9476 8.9784C59.9603 8.50359 59.9666 8.02245 59.9729 7.54764L55.668 14.7268C56.7316 24.6093 72.432 24.4826 72.8689 14.0494V4.86335H75.2809C75.2809 4.75573 75.186 4.64811 75.1037 4.55315C75.0847 4.52782 75.0593 4.50883 75.0467 4.48984C74.4136 3.7428 73.7109 3.0274 73.0081 2.31202C72.2928 1.58397 71.5774 0.849603 70.9316 0.089902C70.729 -0.125347 70.5644 0.0519169 70.4125 0.216519C70.3872 0.241842 70.3682 0.267156 70.3429 0.286149C69.6401 0.982541 68.9817 1.71059 68.3233 2.44497C67.6143 3.23 66.9115 4.01502 66.1518 4.75573L66.1455 4.74939Z" fill="#006FEE"/>
    <path d="M49.5833 21.0006V14.3406L50.4443 16.6197L43.2461 4.69873H47.2725L52.7677 13.8278H50.4633L55.9837 4.69873H59.662L52.5144 16.6197L53.3754 14.3406V21.0006H49.5833Z" fill="black"/>
  </svg>
)

export const ResetFiltersIc:React.FC<IconProps> = ({
  className='',
  size = 20,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 4.00005L4 16M3.99995 4L15.9999 16" stroke="#A8A8B0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

export const DollarRoundedIc:React.FC<IconProps> = ({
  className='',
  size = 12,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_56234_119325)">
    <circle cx="6" cy="6" r="5" stroke="#71717A"/>
    <path d="M6 8.5V8.75V9" stroke="#71717A" strokeLinecap="round"/>
    <path d="M6 3V3.25V3.5" stroke="#71717A" strokeLinecap="round"/>
    <path d="M7.5 4.75C7.5 4.05964 6.82843 3.5 6 3.5C5.17157 3.5 4.5 4.05964 4.5 4.75C4.5 5.44036 5.17157 6 6 6C6.82843 6 7.5 6.55964 7.5 7.25C7.5 7.94036 6.82843 8.5 6 8.5C5.17157 8.5 4.5 7.94036 4.5 7.25" stroke="#71717A" strokeLinecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_56234_119325">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const LockRedIc:React.FC<IconProps> = ({
  className='',
  size = 16,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.00002 7.19961V5.59961C4.00002 3.39047 5.79088 1.59961 8.00002 1.59961C10.2092 1.59961 12 3.39047 12 5.59961V7.19961C12.8837 7.19961 13.6 7.91595 13.6 8.79961V12.7996C13.6 13.6833 12.8837 14.3996 12 14.3996H4.00002C3.11637 14.3996 2.40002 13.6833 2.40002 12.7996V8.79961C2.40002 7.91595 3.11637 7.19961 4.00002 7.19961ZM10.4 5.59961V7.19961H5.60002V5.59961C5.60002 4.27413 6.67454 3.19961 8.00002 3.19961C9.3255 3.19961 10.4 4.27413 10.4 5.59961Z" fill="#F31260"/>
  </svg>
)

export const GreenTgIc:React.FC<IconProps> = ({
  className='',
  size = 48,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_56209_58655)">
    <rect x="6" y="6" width="36" height="36" rx="18" fill="#E8FAF0" shape-rendering="crispEdges"/>
    <rect x="6.5" y="6.5" width="35" height="35" rx="17.5" stroke="#D1F4DF" shape-rendering="crispEdges"/>
    <path d="M27.6637 28.3233L29.7507 22.0624C30.278 20.4806 30.6383 19.3998 30.6639 18.6526C30.6725 18.4009 30.3883 18.3173 30.2103 18.4954L20.5711 28.1346C20.4155 28.2902 20.4525 28.5523 20.6642 28.6122C20.685 28.618 20.706 28.6236 20.7271 28.6287C21.0604 28.7103 21.4959 28.6512 22.3668 28.533L22.4145 28.5265C22.66 28.4932 22.7827 28.4765 22.9006 28.4836C23.1146 28.4966 23.3212 28.5662 23.4993 28.6855C23.5974 28.7513 23.6851 28.8389 23.8603 29.0141L24.0278 29.1816C25.0346 30.1884 25.538 30.6918 26.0721 30.6656C26.2193 30.6583 26.364 30.6242 26.4989 30.5648C26.9883 30.3494 27.2134 29.674 27.6637 28.3233Z" fill="#0E793C"/>
    <path d="M25.936 18.2478L19.7152 20.3213C18.3273 20.7839 17.6334 21.0152 17.4228 21.5241C17.3732 21.6437 17.3433 21.7705 17.3341 21.8996C17.2949 22.449 17.8121 22.9662 18.8466 24.0006L19.035 24.189C19.2048 24.3588 19.2897 24.4437 19.3539 24.5382C19.4805 24.7246 19.5523 24.9427 19.5613 25.1678C19.5659 25.282 19.548 25.4007 19.5124 25.6382C19.3819 26.5073 19.3167 26.9419 19.3936 27.2764C19.3962 27.288 19.399 27.2996 19.4019 27.3112C19.4562 27.5278 19.7224 27.5691 19.8803 27.4112L29.5031 17.7883C29.6812 17.6102 29.5976 17.326 29.3459 17.3347C28.5987 17.3603 27.5179 17.7205 25.936 18.2478Z" fill="#0E793C"/>
    </g>
    <defs>
    <filter id="filter0_d_56209_58655" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.317647 0 0 0 0 0.737255 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_56209_58655"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_56209_58655" result="shape"/>
    </filter>
    </defs>
  </svg>
)

export const SuccesInfoGreenIc:React.FC<IconProps> = ({
  className='',
  size = 48,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_56209_58649)">
    <rect x="6" y="6" width="36" height="36" rx="18" fill="#E8FAF0" shape-rendering="crispEdges"/>
    <rect x="6.5" y="6.5" width="35" height="35" rx="17.5" stroke="#D1F4DF" shape-rendering="crispEdges"/>
    <path d="M24 16C19.582 16 16 19.582 16 24C16 28.418 19.582 32 24 32C28.418 32 32 28.418 32 24C32 19.582 28.418 16 24 16ZM24.6667 28H23.3333V23.3333H24.6667V28ZM24 21.6667C23.448 21.6667 23 21.2187 23 20.6667C23 20.1147 23.448 19.6667 24 19.6667C24.552 19.6667 25 20.1147 25 20.6667C25 21.2187 24.552 21.6667 24 21.6667Z" fill="#10793C"/>
    </g>
    <defs>
    <filter id="filter0_d_56209_58649" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.317647 0 0 0 0 0.737255 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_56209_58649"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_56209_58649" result="shape"/>
    </filter>
    </defs>
  </svg>
)

export const IcTgBlue:React.FC<IconProps> = ({
  className='',
  size = 20,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99935 1.66675C7.78921 1.66675 5.6696 2.54472 4.10679 4.10752C2.54399 5.67033 1.66602 7.78994 1.66602 10.0001C1.66602 12.2102 2.54399 14.3298 4.10679 15.8926C5.6696 17.4554 7.78921 18.3334 9.99935 18.3334C12.2095 18.3334 14.3291 17.4554 15.8919 15.8926C17.4547 14.3298 18.3327 12.2102 18.3327 10.0001C18.3327 7.78994 17.4547 5.67033 15.8919 4.10752C14.3291 2.54472 12.2095 1.66675 9.99935 1.66675Z" fill="#29B6F6"/>
    <path d="M14.1452 6.24992L12.5843 14.2191C12.5843 14.2191 12.5173 14.5833 12.0656 14.5833C11.8256 14.5833 11.7018 14.4691 11.7018 14.4691L8.32102 11.6637L6.66685 10.8299L4.54393 10.2653C4.54393 10.2653 4.16602 10.1562 4.16602 9.84367C4.16602 9.58325 4.55477 9.45909 4.55477 9.45909L13.4364 5.93075C13.4364 5.93075 13.7077 5.83284 13.9056 5.83325C14.0273 5.83325 14.166 5.88534 14.166 6.04159C14.166 6.14575 14.1452 6.24992 14.1452 6.24992Z" fill="white"/>
    <path d="M9.58367 12.7103L8.15617 14.1162C8.15617 14.1162 8.09409 14.1641 8.01117 14.1662C7.98242 14.167 7.95159 14.1624 7.91992 14.1483L8.32159 11.6628L9.58367 12.7103Z" fill="#B0BEC5"/>
    <path d="M12.4564 7.58162C12.386 7.48996 12.256 7.47329 12.1643 7.54287L6.66602 10.8333C6.66602 10.8333 7.54352 13.2883 7.67727 13.7133C7.81143 14.1387 7.91893 14.1487 7.91893 14.1487L8.3206 11.6633L12.4173 7.87329C12.5089 7.80371 12.526 7.67329 12.4564 7.58162Z" fill="#CFD8DC"/>
  </svg>
)

export const CloseButton:React.FC<IconProps> = ({
  className='',
  fill="none",
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 4.50005L4 16.5M3.99995 4.5L15.9999 16.5" stroke="#A8A8B0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

export const ClockIcGrey:React.FC<IconProps> = ({
  className='',
  size = 14,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.0013 1.16797C3.78714 1.16797 1.16797 3.78714 1.16797 7.0013C1.16797 10.2155 3.78714 12.8346 7.0013 12.8346C10.2155 12.8346 12.8346 10.2155 12.8346 7.0013C12.8346 3.78714 10.2155 1.16797 7.0013 1.16797ZM9.5388 9.0838C9.45714 9.2238 9.3113 9.29964 9.15964 9.29964C9.0838 9.29964 9.00797 9.28214 8.93797 9.23547L7.12964 8.1563C6.68047 7.88797 6.34797 7.2988 6.34797 6.77964V4.38797C6.34797 4.1488 6.5463 3.95047 6.78547 3.95047C7.02464 3.95047 7.22297 4.1488 7.22297 4.38797V6.77964C7.22297 6.98964 7.39797 7.2988 7.5788 7.4038L9.38714 8.48297C9.59714 8.60547 9.66714 8.8738 9.5388 9.0838Z" fill="#71717A"/>
  </svg>
)

export const RefreshGreyIc:React.FC<IconProps> = ({
  className='',
  size = 14,
  fill="none",
}) => (
  <svg
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.02224 2.02029C1.16797 2.87456 1.16797 4.24949 1.16797 6.99935C1.16797 9.74921 1.16797 11.1241 2.02224 11.9784C2.87651 12.8327 4.25144 12.8327 7.0013 12.8327C9.75116 12.8327 11.1261 12.8327 11.9804 11.9784C12.8346 11.1241 12.8346 9.74921 12.8346 6.99935C12.8346 4.24949 12.8346 2.87456 11.9804 2.02029C11.1261 1.16602 9.75116 1.16602 7.0013 1.16602C4.25144 1.16602 2.87651 1.16602 2.02224 2.02029ZM3.18664 6.46463C3.40408 4.54928 5.032 3.06185 7.0069 3.06185C8.16306 3.06185 9.20056 3.57209 9.90483 4.37816C10.0638 4.56012 10.0452 4.8365 9.86322 4.99548C9.68126 5.15446 9.40488 5.13583 9.2459 4.95387C8.70088 4.33007 7.9002 3.93685 7.0069 3.93685C5.51506 3.93685 4.28088 5.03479 4.06907 6.46463H4.28095C4.45796 6.46463 4.61753 6.57128 4.68521 6.73484C4.75289 6.8984 4.71535 7.08662 4.5901 7.2117L3.90861 7.89225C3.73781 8.06283 3.46113 8.06283 3.29032 7.89225L2.60883 7.2117C2.48359 7.08662 2.44605 6.8984 2.51373 6.73484C2.58141 6.57128 2.74097 6.46463 2.91798 6.46463H3.18664ZM10.094 6.10644C10.2649 5.93587 10.5415 5.93587 10.7123 6.10644L11.3938 6.787C11.5191 6.91208 11.5566 7.1003 11.4889 7.26386C11.4213 7.42741 11.2617 7.53407 11.0847 7.53407H10.816C10.5986 9.44942 8.97066 10.9368 6.99577 10.9368C5.8396 10.9368 4.80211 10.4266 4.09784 9.62054C3.93886 9.43858 3.95749 9.1622 4.13944 9.00322C4.3214 8.84424 4.59778 8.86287 4.75676 9.04483C5.30178 9.66863 6.10246 10.0618 6.99577 10.0618C8.48761 10.0618 9.72178 8.96391 9.93359 7.53407H9.72171C9.5447 7.53407 9.38514 7.42741 9.31746 7.26386C9.24977 7.1003 9.28731 6.91208 9.41256 6.787L10.094 6.10644Z" fill="#71717A"/>
  </svg>
)

export const OfferFilterIc:React.FC<IconProps> = ({
  className='',
  size = 20,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5013 18.3327H12.5013C16.668 18.3327 18.3346 16.666 18.3346 12.4993V7.49935C18.3346 3.33268 16.668 1.66602 12.5013 1.66602H7.5013C3.33464 1.66602 1.66797 3.33268 1.66797 7.49935V12.4993C1.66797 16.666 3.33464 18.3327 7.5013 18.3327Z" stroke="#A8A8B0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.125 7.5H6.875" stroke="#A8A8B0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.125 12.5H6.875" stroke="#A8A8B0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const StatusFilterOrdersIc:React.FC<IconProps> = ({
  className='',
  size = 20,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.07395 11.0667H7.64895V17.0667C7.64895 18.4667 8.40728 18.7501 9.33228 17.7001L15.6406 10.5334C16.4156 9.65841 16.0906 8.93341 14.9156 8.93341H12.3406V2.93341C12.3406 1.53341 11.5823 1.25008 10.6573 2.30008L4.34895 9.46674C3.58228 10.3501 3.90728 11.0667 5.07395 11.0667Z" stroke="#A8A8B0" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const MessageIc:React.FC<IconProps> = ({
  className='',
  size = 12,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_56342_39303)">
    <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 6.79984 1.18781 7.55582 1.52173 8.22624C1.61047 8.4044 1.64 8.60803 1.58856 8.80031L1.29076 9.91333C1.16148 10.3965 1.60351 10.8385 2.08667 10.7092L3.19969 10.4114C3.39197 10.36 3.5956 10.3895 3.77376 10.4783C4.44418 10.8122 5.20016 11 6 11Z" stroke="#71717A"/>
    <path d="M4 5.25H8" stroke="#71717A" strokeLinecap="round"/>
    <path d="M4 7H6.75" stroke="#71717A" strokeLinecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_56342_39303">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)


export const TicketBillIc:React.FC<IconProps> = ({
  className='',
  size = 12,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.37749 1H3.62251C3.04307 1 2.75335 1 2.51969 1.0813C2.07661 1.23548 1.72874 1.59359 1.57898 2.04973C1.5 2.29027 1.5 2.58853 1.5 3.18503V10.1871C1.5 10.6162 1.9925 10.8439 2.30405 10.5588C2.48709 10.3913 2.76291 10.3913 2.94595 10.5588L3.1875 10.7798C3.50829 11.0734 3.99171 11.0734 4.3125 10.7798C4.63329 10.4863 5.11671 10.4863 5.4375 10.7798C5.75829 11.0734 6.24171 11.0734 6.5625 10.7798C6.88329 10.4863 7.36671 10.4863 7.6875 10.7798C8.00829 11.0734 8.49171 11.0734 8.8125 10.7798L9.05405 10.5588C9.23709 10.3913 9.51291 10.3913 9.69595 10.5588C10.0075 10.8439 10.5 10.6162 10.5 10.1871V3.18503C10.5 2.58853 10.5 2.29027 10.421 2.04973C10.2713 1.59359 9.92339 1.23548 9.48031 1.0813C9.24665 1 8.95693 1 8.37749 1Z" stroke="#71717A"/>
    <path d="M4.75 5.2L5.46429 6L7.25 4" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.75 7.75H8.25" stroke="#71717A" strokeLinecap="round"/>
  </svg>
)

export const WalletIc:React.FC<IconProps> = ({
  className='',
  size = 12,
  fill="none",
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 4H5" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.4167 4.5H9.11538C8.22323 4.5 7.5 5.17157 7.5 6C7.5 6.82843 8.22323 7.5 9.11538 7.5H10.4167C10.4583 7.5 10.4792 7.5 10.4968 7.49893C10.7664 7.48252 10.9812 7.28308 10.9988 7.0327C11 7.01637 11 6.99702 11 6.95833V5.04167C11 5.00298 11 4.98363 10.9988 4.9673C10.9812 4.71692 10.7664 4.51748 10.4968 4.50107C10.4792 4.5 10.4583 4.5 10.4167 4.5Z" stroke="#71717A"/>
    <path d="M10.4825 4.5C10.4436 3.56385 10.3183 2.98987 9.91421 2.58579C9.32843 2 8.38562 2 6.5 2L5 2C3.11438 2 2.17157 2 1.58579 2.58579C1 3.17157 1 4.11438 1 6C1 7.88562 1 8.82843 1.58579 9.41421C2.17157 10 3.11438 10 5 10H6.5C8.38562 10 9.32843 10 9.91421 9.41421C10.3183 9.01013 10.4436 8.43615 10.4825 7.5" stroke="#71717A"/>
    <path d="M8.99611 6H9.00061" stroke="#71717A" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ArrowRightLang:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.72481 6.64155C3.9467 6.41967 4.29391 6.39949 4.53859 6.58104L4.60869 6.64155L10.0001 12.0327L15.3915 6.64155C15.6134 6.41967 15.9606 6.39949 16.2053 6.58104L16.2754 6.64155C16.4972 6.86344 16.5174 7.21066 16.3359 7.45534L16.2754 7.52544L10.442 13.3588C10.2201 13.5807 9.87291 13.6008 9.62824 13.4193L9.55814 13.3588L3.72481 7.52544C3.48073 7.28136 3.48073 6.88563 3.72481 6.64155Z" fill="#11181C"/>
  </svg>
)

export const LvlCheck:React.FC<IconProps> = ({

}) => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.9219 4.4107C18.2474 4.73614 18.2474 5.26378 17.9219 5.58922L8.75527 14.7559C8.42983 15.0813 7.9022 15.0813 7.57676 14.7559L3.41009 10.5892C3.08466 10.2638 3.08466 9.73614 3.41009 9.4107C3.73553 9.08527 4.26317 9.08527 4.5886 9.4107L8.16602 12.9881L16.7434 4.4107C17.0689 4.08527 17.5965 4.08527 17.9219 4.4107Z" fill="white"/>
  </svg>
)

export const MedalIc:React.FC<IconProps> = ({

}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.43063 4.68168C7.68396 4.22723 7.81063 4 8 4C8.18937 4 8.31604 4.22722 8.56937 4.68167L8.63491 4.79925C8.70689 4.92839 8.74289 4.99296 8.79901 5.03556C8.85513 5.07817 8.92503 5.09398 9.06482 5.12561L9.19209 5.15441C9.68403 5.26571 9.93 5.32136 9.98852 5.50955C10.047 5.69773 9.87935 5.89381 9.54398 6.28598L9.45722 6.38744C9.36191 6.49889 9.31426 6.55461 9.29283 6.62354C9.27139 6.69248 9.27859 6.76682 9.293 6.91551L9.30612 7.05088C9.35682 7.57412 9.38218 7.83574 9.22897 7.95204C9.07576 8.06835 8.84546 7.96231 8.38487 7.75023L8.2657 7.69537C8.13481 7.6351 8.06937 7.60497 8 7.60497C7.93063 7.60497 7.86519 7.6351 7.7343 7.69537L7.61513 7.75023C7.15453 7.96231 6.92424 8.06835 6.77103 7.95204C6.61782 7.83574 6.64318 7.57412 6.69388 7.05088L6.707 6.91551C6.72141 6.76682 6.72861 6.69248 6.70717 6.62354C6.68574 6.55461 6.63809 6.49889 6.54278 6.38744L6.45602 6.28599C6.12065 5.89381 5.95296 5.69773 6.01148 5.50955C6.07 5.32136 6.31597 5.26571 6.80791 5.15441L6.93518 5.12561C7.07497 5.09398 7.14487 5.07817 7.20099 5.03556C7.25711 4.99296 7.29311 4.92839 7.36509 4.79925L7.43063 4.68168Z" stroke="#A8A8B0"/>
    <path d="M12.6668 6.00065C12.6668 8.57798 10.5775 10.6673 8.00016 10.6673C5.42283 10.6673 3.3335 8.57798 3.3335 6.00065C3.3335 3.42332 5.42283 1.33398 8.00016 1.33398C10.5775 1.33398 12.6668 3.42332 12.6668 6.00065Z" stroke="#A8A8B0"/>
    <path d="M4.90074 10L4.47616 11.5486C4.05727 13.0765 3.84782 13.8405 4.12732 14.2587C4.22527 14.4053 4.35667 14.5229 4.50915 14.6006C4.94423 14.8221 5.61601 14.4721 6.95955 13.772C7.40659 13.539 7.63011 13.4226 7.86762 13.3973C7.95565 13.3879 8.04435 13.3879 8.13238 13.3973C8.36989 13.4226 8.59341 13.539 9.04045 13.772C10.384 14.4721 11.0558 14.8221 11.4909 14.6006C11.6433 14.5229 11.7747 14.4053 11.8727 14.2587C12.1522 13.8405 11.9427 13.0765 11.5238 11.5486L11.0993 10" stroke="#A8A8B0" strokeLinecap="round"/>
  </svg>
)

export const DoubleArrowsClient:React.FC<IconProps> = ({

}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33301 12.6673L11.333 8.00065L7.33301 3.33398" stroke="#9675CE" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.66699 12.6673L8.66699 8.00065L4.66699 3.33398" stroke="#9675CE" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const BronzeLvl:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg
    width={size} 
    height={size} 
    className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.0003" cy="7.49935" r="5.83333" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M6.12593 12.5L5.5952 14.4358C5.07158 16.3457 4.80977 17.3006 5.15914 17.8234C5.28158 18.0066 5.44583 18.1537 5.63643 18.2507C6.18029 18.5276 7.02001 18.0901 8.69944 17.215C9.25824 16.9238 9.53764 16.7782 9.83452 16.7466C9.94457 16.7349 10.0554 16.7349 10.1655 16.7466C10.4624 16.7782 10.7418 16.9238 11.3006 17.215C12.98 18.0901 13.8197 18.5276 14.3636 18.2507C14.5542 18.1537 14.7184 18.0066 14.8409 17.8234C15.1902 17.3006 14.9284 16.3457 14.4048 14.4358L13.8741 12.5" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round"/>
  </svg>
)

export const SilverLvl:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.28829 5.85209C9.60495 5.28403 9.76328 5 10 5C10.2367 5 10.395 5.28403 10.7117 5.85209L10.7936 5.99906C10.8836 6.16048 10.9286 6.2412 10.9988 6.29445C11.0689 6.34771 11.1563 6.36748 11.331 6.40701L11.4901 6.44301C12.105 6.58214 12.4125 6.6517 12.4856 6.88693C12.5588 7.12216 12.3492 7.36727 11.93 7.85748L11.8215 7.98431C11.7024 8.12361 11.6428 8.19326 11.616 8.27943C11.5892 8.3656 11.5982 8.45853 11.6163 8.64439L11.6327 8.8136C11.696 9.46765 11.7277 9.79468 11.5362 9.94005C11.3447 10.0854 11.0568 9.95289 10.4811 9.68779L10.3321 9.61921C10.1685 9.54388 10.0867 9.50621 10 9.50621C9.91329 9.50621 9.83148 9.54388 9.66787 9.61921L9.51892 9.68779C8.94317 9.95289 8.65529 10.0854 8.46379 9.94005C8.27228 9.79468 8.30397 9.46765 8.36735 8.8136L8.38375 8.64439C8.40176 8.45853 8.41076 8.3656 8.38397 8.27943C8.35717 8.19326 8.29761 8.12361 8.17848 7.98431L8.07002 7.85748C7.65081 7.36727 7.44121 7.12216 7.51436 6.88693C7.5875 6.6517 7.89496 6.58214 8.50988 6.44301L8.66897 6.40701C8.84371 6.36748 8.93108 6.34771 9.00124 6.29445C9.07139 6.2412 9.11638 6.16048 9.20637 5.99906L9.28829 5.85209Z" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M15.8337 7.49935C15.8337 10.721 13.222 13.3327 10.0003 13.3327C6.77866 13.3327 4.16699 10.721 4.16699 7.49935C4.16699 4.27769 6.77866 1.66602 10.0003 1.66602C13.222 1.66602 15.8337 4.27769 15.8337 7.49935Z" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M6.12593 12.5L5.5952 14.4358C5.07158 16.3457 4.80977 17.3006 5.15914 17.8234C5.28158 18.0066 5.44583 18.1537 5.63643 18.2507C6.18029 18.5276 7.02001 18.0901 8.69944 17.215C9.25824 16.9238 9.53764 16.7782 9.83452 16.7466C9.94457 16.7349 10.0554 16.7349 10.1655 16.7466C10.4624 16.7782 10.7418 16.9238 11.3006 17.215C12.98 18.0901 13.8197 18.5276 14.3636 18.2507C14.5542 18.1537 14.7184 18.0066 14.8409 17.8234C15.1902 17.3006 14.9284 16.3457 14.4048 14.4358L13.8741 12.5" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round"/>
  </svg>

)

export const GoldLvl:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.28829 5.85209C9.60495 5.28403 9.76328 5 10 5C10.2367 5 10.395 5.28403 10.7117 5.85209L10.7936 5.99906C10.8836 6.16048 10.9286 6.2412 10.9988 6.29445C11.0689 6.34771 11.1563 6.36748 11.331 6.40701L11.4901 6.44301C12.105 6.58214 12.4125 6.6517 12.4856 6.88693C12.5588 7.12216 12.3492 7.36727 11.93 7.85748L11.8215 7.98431C11.7024 8.12361 11.6428 8.19326 11.616 8.27943C11.5892 8.3656 11.5982 8.45853 11.6163 8.64439L11.6327 8.8136C11.696 9.46765 11.7277 9.79468 11.5362 9.94005C11.3447 10.0854 11.0568 9.95289 10.4811 9.68779L10.3321 9.61921C10.1685 9.54388 10.0867 9.50621 10 9.50621C9.91329 9.50621 9.83148 9.54388 9.66787 9.61921L9.51892 9.68779C8.94317 9.95289 8.65529 10.0854 8.46379 9.94005C8.27228 9.79468 8.30397 9.46765 8.36735 8.8136L8.38375 8.64439C8.40176 8.45853 8.41076 8.3656 8.38397 8.27943C8.35717 8.19326 8.29761 8.12361 8.17848 7.98431L8.07002 7.85748C7.65081 7.36727 7.44121 7.12216 7.51436 6.88693C7.5875 6.6517 7.89496 6.58214 8.50988 6.44301L8.66897 6.40701C8.84371 6.36748 8.93108 6.34771 9.00124 6.29445C9.07139 6.2412 9.11638 6.16048 9.20637 5.99906L9.28829 5.85209Z" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M15.8337 7.49935C15.8337 10.721 13.222 13.3327 10.0003 13.3327C6.77866 13.3327 4.16699 10.721 4.16699 7.49935C4.16699 4.27769 6.77866 1.66602 10.0003 1.66602C13.222 1.66602 15.8337 4.27769 15.8337 7.49935Z" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M10.0003 13.3899L6.85745 16.644C6.40735 17.11 6.1823 17.3431 5.99171 17.4237C5.55742 17.6074 5.07568 17.4502 4.84722 17.0501C4.74697 16.8746 4.71573 16.5579 4.65324 15.9246C4.61797 15.567 4.60033 15.3882 4.54678 15.2384C4.42692 14.9032 4.17504 14.6424 3.85125 14.5182C3.70661 14.4628 3.53393 14.4445 3.18857 14.408C2.57688 14.3433 2.27104 14.311 2.10148 14.2072C1.71509 13.9706 1.56322 13.4718 1.74068 13.0222C1.81856 12.8248 2.04361 12.5918 2.49371 12.1258L4.54678 10" stroke="#A8A8B0" stroke-width="1.2"/>
    <path d="M9.99967 13.3899L13.1426 16.644C13.5927 17.11 13.8177 17.3431 14.0083 17.4237C14.4426 17.6074 14.9243 17.4502 15.1528 17.0501C15.253 16.8746 15.2843 16.5579 15.3468 15.9246C15.382 15.567 15.3997 15.3882 15.4532 15.2384C15.5731 14.9032 15.825 14.6424 16.1488 14.5182C16.2934 14.4628 16.4661 14.4445 16.8114 14.408C17.4231 14.3433 17.729 14.311 17.8985 14.2072C18.2849 13.9706 18.4368 13.4718 18.2593 13.0222C18.1814 12.8248 17.9564 12.5918 17.5063 12.1258L15.4532 10" stroke="#A8A8B0" stroke-width="1.2"/>
  </svg>

)

export const PlatinumLvl:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.0078 11.3006L18.1988 9.27128C18.3488 7.67743 18.4238 6.88051 18.1512 6.55108C18.0037 6.37287 17.8031 6.26368 17.5887 6.24485C17.1923 6.21003 16.6944 6.77677 15.6988 7.91024C15.1839 8.49643 14.9264 8.78952 14.6392 8.83491C14.48 8.86006 14.3179 8.8342 14.1709 8.76025C13.9057 8.62678 13.7289 8.26445 13.3753 7.53978L11.5112 3.72006C10.843 2.3507 10.5088 1.66602 10.0003 1.66602C9.49183 1.66602 9.1577 2.3507 8.48944 3.72006L6.62539 7.53978C6.27174 8.26445 6.09492 8.62678 5.82971 8.76025C5.68276 8.8342 5.52061 8.86006 5.36147 8.83491C5.07426 8.78952 4.8168 8.49643 4.30188 7.91024C3.30623 6.77677 2.8084 6.21003 2.41198 6.24485C2.19754 6.26368 1.99697 6.37287 1.84948 6.55108C1.57682 6.88051 1.65183 7.67743 1.80183 9.27128L1.99283 11.3006C2.30754 14.6445 2.46489 16.3164 3.4504 17.3245C4.43592 18.3327 5.91296 18.3327 8.86706 18.3327H11.1336C14.0877 18.3327 15.5647 18.3327 16.5502 17.3245C17.5358 16.3164 17.6931 14.6445 18.0078 11.3006Z" stroke="#A8A8B0" stroke-width="1.2"/>
  </svg>
)

export const DiamondLvl:React.FC<IconProps> = ({
  className='',
  size = 20,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.7005 7.50589L16.4701 3.55187C16.2484 3.15901 15.8323 2.91602 15.3813 2.91602H4.61918C4.16814 2.91602 3.75206 3.15901 3.53045 3.55187L1.29998 7.50589C1.02429 7.9946 1.10805 8.60714 1.50482 9.00393L9.41097 16.9101C9.73643 17.2355 10.2641 17.2355 10.5895 16.9101L18.4957 9.00393C18.8924 8.60714 18.9762 7.9946 18.7005 7.50589Z" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.82182 2.91602L6.59049 7.80777C6.50457 8.14893 6.52886 8.50852 6.65982 8.83506L9.99649 17.1542C9.99882 17.1542 10.0035 17.1542 10.0035 17.1542" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.1776 2.91602L13.4089 7.80777C13.4948 8.14893 13.4705 8.50852 13.3396 8.83506L10.0029 17.1542" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.25 8.33398H18.75" stroke="#A8A8B0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const PublicLinkIc:React.FC<IconProps> = ({
  className='',
  size = 24,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7917 15.7991L14.2223 14.3676C16.5926 11.9959 16.5926 8.15054 14.2223 5.7788C11.8521 3.40707 8.0091 3.40707 5.63885 5.7788L2.77769 8.64174C0.407436 11.0135 0.407436 14.8588 2.77769 17.2306C3.87688 18.3304 5.29279 18.9202 6.73165 19" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M11.2083 8.20092L9.77769 9.63239C7.40744 12.0041 7.40744 15.8495 9.77769 18.2212C12.1479 20.5929 15.9909 20.5929 18.3612 18.2212L21.2223 15.3583C23.5926 12.9865 23.5926 9.14118 21.2223 6.76945C20.1231 5.66957 18.7072 5.07976 17.2683 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
)

export const CheckArrowGreen:React.FC<IconProps> = ({
  className='',
  size = 16,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8.45L5.85714 11.25L13 4.25" stroke="#19BE60" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)


export const ArrowSortDown:React.FC<IconProps> = ({
  className='',
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.23483 3.98483C2.36797 3.8517 2.5763 3.8396 2.72311 3.94853L2.76517 3.98483L6 7.2195L9.23484 3.98483C9.36797 3.8517 9.5763 3.8396 9.72311 3.94853L9.76517 3.98483C9.8983 4.11797 9.9104 4.3263 9.80148 4.47311L9.76517 4.51517L6.26517 8.01516C6.13203 8.1483 5.9237 8.1604 5.77689 8.05147L5.73484 8.01516L2.23483 4.51517C2.08839 4.36872 2.08839 4.13128 2.23483 3.98483Z" fill="#71717A"/>
  </svg>
)

export const ArrowSortUp:React.FC<IconProps> = ({
  className='',
  size = 12,
}) => (
  <svg 
    width={size} 
    height={size} 
    className={className} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.23483 8.01517C2.36797 8.1483 2.5763 8.1604 2.72311 8.05147L2.76517 8.01517L6 4.7805L9.23484 8.01517C9.36797 8.1483 9.5763 8.1604 9.72311 8.05147L9.76517 8.01517C9.8983 7.88203 9.9104 7.6737 9.80148 7.52689L9.76517 7.48483L6.26517 3.98484C6.13203 3.8517 5.9237 3.8396 5.77689 3.94853L5.73484 3.98484L2.23483 7.48483C2.08839 7.63128 2.08839 7.86872 2.23483 8.01517Z" fill="#71717A"/>
  </svg>
)

export const UserGroup2:React.FC<IconProps> = ({
  className='',
  size = 12,
}) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4.5" cy="3" r="2" stroke="#71717A"/>
    <path d="M7.5 4.5C8.32843 4.5 9 3.82843 9 3C9 2.17157 8.32843 1.5 7.5 1.5" stroke="#71717A" stroke-linecap="round"/>
    <ellipse cx="4.5" cy="8.5" rx="3.5" ry="2" stroke="#71717A"/>
    <path d="M9 7C9.87712 7.19235 10.5 7.67947 10.5 8.25C10.5 8.76467 9.99313 9.21146 9.25 9.43522" stroke="#71717A" stroke-linecap="round"/>
  </svg>
)

export const BlueCircleIc:React.FC<IconProps> = ({
  className='',
  size = 8,
}) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="#006FEE"/>
  </svg>
)